var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEinspeiseanfrage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 329,
    viewBox: "0 0 457 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Einspeiseanfrage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.728 328.133L0.144775 191.566L0.179688 172.38L38.8348 154.823L252.182 290.877V316.441L236.728 328.133Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M236.733 328.509L0.14502 191.913V189.374L236.733 326.116V328.509Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M456.69 201.763L236.732 328.51L236.732 269.55L417.784 170.033L456.674 182.172L456.69 201.763Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.14502 172.43L236.727 309.719L456.675 182.172L219.948 57.3381L0.14502 172.43Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Baum"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M199.42 115.389C205.879 118.054 205.879 122.451 199.42 125.231C192.145 127.953 183.537 127.953 176.263 125.231C169.805 122.567 169.805 118.169 176.263 115.389C183.537 112.667 192.145 112.667 199.42 115.389Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M187.482 120.114L184.039 99.4195C184.121 100.264 183.7 100.907 182.775 101.489C181.023 102.591 178.118 102.743 176.288 101.776C175.338 101.274 174.865 100.613 174.875 99.9191L174.872 99.9191L172.797 121.513C172.688 122.73 173.459 123.932 175.097 124.797C178.087 126.377 182.831 126.177 185.693 124.377C187.605 123.174 188.192 121.529 187.482 120.114Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M171.587 60.2489C181.163 60.2489 188.926 68.2546 188.926 78.1292C188.926 88.0038 181.163 96.0095 171.587 96.0095C162.011 96.0095 154.249 88.0038 154.249 78.1292C154.249 68.2546 162.011 60.2489 171.587 60.2489Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M181.375 73.9916C175.669 77.1188 166.423 77.1188 160.716 73.9916C158.115 72.6019 156.742 70.7257 156.453 68.9182C156.164 71.2122 157.537 73.5045 160.716 75.242C166.423 78.3693 175.669 78.3693 181.375 75.242C184.483 73.5045 185.927 71.2111 185.638 68.9182C185.349 70.7944 183.978 72.599 181.375 73.9916Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M182.906 86.546C176.354 90.0641 165.738 90.0641 159.186 86.546C156.199 84.9826 154.624 82.8719 154.292 80.8384C153.959 83.4192 155.536 85.998 159.186 87.9527C165.738 91.4709 176.354 91.4709 182.906 87.9527C186.473 85.998 188.132 83.4179 187.8 80.8384C187.468 82.9492 185.893 84.9793 182.906 86.546Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M186.758 68.9182C196.334 68.9182 204.097 76.9239 204.097 86.7985C204.097 96.6731 196.334 104.679 186.758 104.679C177.182 104.679 169.42 96.6731 169.42 86.7985C169.42 76.9239 177.182 68.9182 186.758 68.9182Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M197.471 82.6609C191.553 85.7881 181.965 85.7881 176.046 82.6609C173.349 81.2712 171.926 79.3949 171.626 77.5875C171.326 79.8815 172.75 82.1737 176.046 83.9113C181.965 87.0385 191.553 87.0385 197.471 83.9113C200.694 82.1737 202.192 79.8803 201.892 77.5875C201.592 79.4637 200.17 81.2682 197.471 82.6609Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M199.161 95.2153C192.609 98.7334 181.993 98.7334 175.441 95.2153C172.455 93.6519 170.879 91.5411 170.547 89.5077C170.215 92.0885 171.791 94.6672 175.441 96.622C181.993 100.14 192.609 100.14 199.161 96.622C202.729 94.6672 204.387 92.0871 204.055 89.5077C203.723 91.6184 202.149 93.6485 199.161 95.2153Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M171.587 84.0894C178.171 84.0894 183.508 89.6691 183.508 96.5515C183.508 103.434 178.171 109.013 171.587 109.013C165.004 109.013 159.667 103.434 159.667 96.5515C159.667 89.6691 165.004 84.0894 171.587 84.0894Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M178.315 94.3964C174.299 96.7418 167.793 96.7418 163.777 94.3964C161.946 93.3541 160.981 91.947 160.777 90.5914C160.574 92.3119 161.54 94.0311 163.777 95.3342C167.793 97.6797 174.299 97.6797 178.315 95.3342C180.502 94.0311 181.518 92.311 181.315 90.5914C181.111 91.9985 180.146 93.3519 178.315 94.3964Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M180.005 103.066C175.355 105.411 167.821 105.411 163.171 103.066C161.052 102.023 159.933 100.616 159.698 99.2606C159.462 100.981 160.581 102.7 163.171 104.003C167.821 106.349 175.355 106.349 180.005 104.003C182.537 102.7 183.714 100.98 183.478 99.2606C183.242 100.668 182.125 102.021 180.005 103.066Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Mastboden",
    d: "M144.93 186.407L112.185 205.313L79.4389 186.407L112.185 167.501L144.93 186.407Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Kabel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 334",
    d: "M123.936 190.214L233.336 255.415L227.501 258.809L118.603 193.454L123.936 190.214Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 335",
    d: "M293.986 214.055L221.635 255.285L227.524 258.818L298.802 216.838L293.986 214.055Z",
    fill: "#B4005F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Einspeiseanfrage_Hide",
    d: "M157.285 254.857L226.621 217.398L297.489 254.857L226.621 294.992L157.285 254.857Z",
    fill: "#65813F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PVGro\xC3\x9F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    d: "M373.804 194.984L362.428 196.203L337.753 182.119L368.376 162.717L399.06 180.361L373.804 194.984Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PVGro\xC3\x9F_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M271.699 135.758L255.886 137.453L221.586 117.874L264.154 90.9052L306.806 115.431L271.699 135.758Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M246.961 123.943C246.961 126.241 243.597 128.105 239.45 128.105C235.302 128.105 231.94 126.241 231.94 123.943C231.94 121.644 235.302 119.78 239.45 119.78C243.597 119.78 246.961 121.644 246.961 123.943Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M246.955 123.809C246.957 123.853 246.961 123.898 246.961 123.942C246.961 126.241 243.599 128.105 239.451 128.105C235.303 128.105 231.94 126.241 231.94 123.942V125.989H231.946C232.059 128.233 235.374 130.033 239.451 130.033C243.599 130.033 246.961 128.17 246.961 125.871V123.809H246.955Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M251.157 59.0645L285.788 79.1817L253.702 132.501L218.013 111.816L251.157 59.0645Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M251.628 60.7073L284.026 79.7046L252.185 130.045L219.778 110.921L251.628 60.7073Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M278.302 86.1771L273.06 83.12C272.536 82.8135 271.807 81.799 272.574 80.7306L275.373 76.3181C275.68 75.8531 276.635 75.6841 277.159 75.9899L282.716 79.2062C283.24 79.512 283.499 80.0944 283.329 80.667L280.223 85.5625C279.733 86.2533 278.826 86.4829 278.302 86.1771Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M270.174 81.4606L264.932 78.4028C264.408 78.097 263.679 77.0825 264.446 76.0141L267.245 71.6016C267.552 71.1366 268.507 70.9676 269.031 71.2734L274.589 74.4897C275.113 74.7955 275.371 75.3771 275.201 75.9506L272.095 80.846C271.605 81.5368 270.699 81.7664 270.174 81.4606Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M273.641 93.2415L268.399 90.1844C267.875 89.8779 267.146 88.8634 267.913 87.795L270.712 83.3825C271.019 82.9174 271.974 82.7485 272.498 83.0543L278.056 86.2706C278.58 86.5764 278.838 87.1588 278.668 87.7314L275.562 92.6269C275.072 93.3177 274.166 93.5473 273.641 93.2415Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M265.483 88.5522L260.241 85.4944C259.716 85.1886 258.988 84.1741 259.755 83.105L262.554 78.6932C262.861 78.2282 263.816 78.0592 264.34 78.365L269.897 81.5813C270.421 81.8871 270.68 82.4687 270.509 83.0422L267.403 87.9377C266.914 88.6285 266.007 88.858 265.483 88.5522Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M262.052 76.719L256.81 73.6612C256.286 73.3554 255.557 72.3409 256.324 71.2725L259.123 66.86C259.43 66.395 260.385 66.226 260.909 66.5318L266.467 69.7481C266.991 70.0539 267.249 70.6355 267.079 71.209L263.973 76.1045C263.483 76.7953 262.576 77.0248 262.052 76.719Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M253.923 72.0026L248.681 68.9448C248.157 68.639 247.428 67.6245 248.195 66.5553L250.994 62.1436C251.301 61.6786 252.256 61.5096 252.781 61.8154L258.338 65.0317C258.862 65.3375 259.12 65.9191 258.95 66.4925L255.844 71.388C255.354 72.0788 254.448 72.3084 253.923 72.0026Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M257.387 83.7824L252.146 80.7254C251.621 80.4188 250.892 79.4043 251.66 78.3359L254.459 73.9234C254.765 73.4584 255.721 73.2894 256.245 73.5952L261.803 76.8115C262.327 77.1173 262.585 77.699 262.413 78.2724L259.308 83.1679C258.818 83.8587 257.911 84.0882 257.387 83.7824Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M249.23 79.0938L243.989 76.0368C243.465 75.7302 242.736 74.7157 243.503 73.6473L246.302 69.2348C246.608 68.7698 247.564 68.6008 248.088 68.9066L253.645 72.1237C254.169 72.4287 254.428 73.0111 254.257 73.5838L251.152 78.4793C250.661 79.1701 249.755 79.3996 249.23 79.0938Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M269.106 100.413L263.865 97.356C263.341 97.0495 262.612 96.035 263.379 94.9666L266.178 90.5541C266.485 90.0891 267.44 89.9201 267.964 90.2259L273.522 93.4422C274.046 93.748 274.304 94.3304 274.133 94.9031L271.027 99.7986C270.537 100.489 269.631 100.719 269.106 100.413Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M260.975 95.6955L255.734 92.6376C255.209 92.3319 254.481 91.3173 255.248 90.249L258.047 85.8365C258.353 85.3714 259.309 85.2025 259.833 85.5082L265.39 88.7245C265.914 89.0303 266.173 89.612 266.002 90.1854L262.896 95.0809C262.406 95.7717 261.499 96.0012 260.975 95.6955Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M264.568 107.63L259.326 104.573C258.802 104.266 258.073 103.252 258.84 102.183L261.639 97.7708C261.946 97.3058 262.901 97.1369 263.426 97.4426L268.983 100.659C269.507 100.965 269.765 101.546 269.595 102.12L266.489 107.015C265.999 107.706 265.093 107.936 264.568 107.63Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M256.385 102.975L251.143 99.9174C250.619 99.6116 249.89 98.5971 250.657 97.5287L253.456 93.1162C253.763 92.6512 254.718 92.4822 255.242 92.788L260.799 96.0043C261.323 96.3101 261.582 96.8917 261.412 97.4651L258.306 102.361C257.816 103.051 256.909 103.281 256.385 102.975Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M252.855 90.9539L247.613 87.8961C247.089 87.5903 246.36 86.5758 247.127 85.5074L249.927 81.0949C250.233 80.6299 251.189 80.4609 251.713 80.7667L257.271 83.983C257.795 84.2888 258.053 84.8704 257.882 85.4438L254.776 90.3393C254.286 91.0301 253.38 91.2597 252.855 90.9539Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M244.724 86.2365L239.483 83.1787C238.959 82.8729 238.23 81.8583 238.997 80.7892L241.796 76.3775C242.102 75.9124 243.058 75.7435 243.582 76.0493L249.139 79.2656C249.663 79.5713 249.922 80.153 249.751 80.7264L246.646 85.6219C246.155 86.3127 245.249 86.5423 244.724 86.2365Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M248.192 98.1464L242.951 95.0886C242.426 94.7828 241.697 93.7683 242.465 92.6991L245.264 88.2874C245.57 87.8224 246.526 87.6534 247.05 87.9592L252.608 91.1755C253.132 91.4813 253.39 92.0629 253.219 92.6363L250.113 97.5318C249.623 98.2226 248.717 98.4522 248.192 98.1464Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M240.029 93.4655L234.787 90.4077C234.263 90.1019 233.534 89.0874 234.302 88.019L237.101 83.6065C237.407 83.1414 238.363 82.9725 238.887 83.2783L244.444 86.4946C244.968 86.8003 245.227 87.382 245.056 87.9554L241.951 92.8509C241.46 93.5417 240.553 93.7713 240.029 93.4655Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M260.141 114.807L254.9 111.749C254.375 111.443 253.647 110.428 254.414 109.36L257.213 104.948C257.519 104.483 258.475 104.314 258.999 104.619L264.557 107.836C265.081 108.141 265.339 108.723 265.168 109.297L262.062 114.192C261.572 114.883 260.665 115.112 260.141 114.807Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M252.015 110.09L246.773 107.032C246.249 106.726 245.52 105.712 246.287 104.643L249.087 100.231C249.393 99.766 250.349 99.5971 250.873 99.9028L256.431 103.119C256.955 103.425 257.213 104.007 257.041 104.58L253.936 109.475C253.446 110.166 252.539 110.396 252.015 110.09Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M255.48 121.87L250.239 118.813C249.715 118.507 248.986 117.492 249.753 116.424L252.552 112.011C252.858 111.546 253.814 111.377 254.338 111.683L259.896 114.9C260.42 115.205 260.678 115.787 260.507 116.36L257.402 121.256C256.911 121.947 256.005 122.176 255.48 121.87Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M247.324 117.181L242.082 114.124C241.558 113.818 240.829 112.803 241.596 111.735L244.395 107.322C244.702 106.857 245.657 106.688 246.181 106.994L251.739 110.21C252.263 110.516 252.521 111.098 252.351 111.671L249.244 116.567C248.755 117.257 247.848 117.487 247.324 117.181Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M243.89 105.348L238.649 102.29C238.124 101.985 237.396 100.97 238.163 99.9009L240.962 95.4891C241.268 95.0241 242.224 94.8551 242.748 95.1609L248.305 98.3772C248.829 98.683 249.088 99.2646 248.917 99.8381L245.812 104.734C245.321 105.424 244.415 105.654 243.89 105.348Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M235.763 100.63L230.521 97.5733C229.997 97.2668 229.268 96.2523 230.035 95.1839L232.834 90.7714C233.141 90.3064 234.096 90.1374 234.62 90.4432L240.178 93.6602C240.702 93.966 240.96 94.5477 240.79 95.1204L237.684 100.016C237.194 100.707 236.288 100.936 235.763 100.63Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M239.231 112.412L233.989 109.354C233.465 109.048 232.736 108.033 233.503 106.965L236.302 102.553C236.609 102.087 237.564 101.919 238.088 102.224L243.646 105.441C244.17 105.746 244.428 106.328 244.258 106.901L241.151 111.797C240.661 112.488 239.755 112.717 239.231 112.412Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M231.068 107.723L225.826 104.665C225.302 104.359 224.573 103.344 225.34 102.276L228.139 97.8636C228.446 97.3986 229.401 97.2296 229.926 97.5354L235.483 100.752C236.007 101.057 236.265 101.639 236.095 102.213L232.989 107.108C232.499 107.799 231.593 108.028 231.068 107.723Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M250.801 129.002L245.56 125.944C245.035 125.639 244.307 124.624 245.074 123.556L247.873 119.143C248.179 118.678 249.135 118.509 249.659 118.815L255.217 122.031C255.741 122.337 255.999 122.919 255.828 123.492L252.722 128.388C252.232 129.078 251.325 129.308 250.801 129.002Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M242.643 124.313L237.401 121.255C236.877 120.949 236.148 119.934 236.915 118.866L239.714 114.454C240.021 113.989 240.976 113.82 241.5 114.125L247.058 117.342C247.582 117.647 247.84 118.229 247.67 118.803L244.564 123.698C244.074 124.389 243.168 124.618 242.643 124.313Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M234.55 119.543L229.308 116.486C228.784 116.18 228.055 115.165 228.822 114.096L231.621 109.684C231.928 109.219 232.883 109.05 233.407 109.356L238.965 112.573C239.489 112.878 239.747 113.46 239.577 114.033L236.471 118.929C235.981 119.62 235.074 119.849 234.55 119.543Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M226.387 114.854L221.145 111.796C220.621 111.49 219.892 110.475 220.659 109.407L223.459 104.995C223.765 104.53 224.721 104.361 225.245 104.666L230.802 107.883C231.326 108.188 231.585 108.77 231.413 109.344L228.308 114.239C227.818 114.93 226.911 115.159 226.387 114.854Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M254.146 62.4096L222.93 112.733L254.146 62.4096Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M254.146 62.4096L222.93 112.733L254.146 62.4096Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M256.183 63.6646L224.967 113.988L256.183 63.6646Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M256.183 63.6646L224.967 113.988L256.183 63.6646Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M262.17 67.2036L230.953 117.527L262.17 67.2036Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M262.17 67.2036L230.953 117.527L262.17 67.2036Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M264.204 68.4589L232.988 118.782L264.204 68.4589Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M264.204 68.4589L232.988 118.782L264.204 68.4589Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M270.191 71.8842L238.975 122.207L270.191 71.8842Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M270.191 71.8842L238.975 122.207L270.191 71.8842Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M272.225 73.1385L241.009 123.462L272.225 73.1385Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M272.225 73.1385L241.009 123.462L272.225 73.1385Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M278.211 76.5643L246.994 126.887L278.211 76.5643Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M278.211 76.5643L246.994 126.887L278.211 76.5643Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M280.243 77.8199L249.027 128.143L280.243 77.8199Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M280.243 77.8199L249.027 128.143L280.243 77.8199Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M251.575 60.5444L251.405 60.6356L284.031 79.7047L284.187 79.6127L251.575 60.5444Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M251.407 60.6349L251.352 60.8219L283.823 79.7384L283.852 79.615L251.407 60.6349Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M284.029 79.7026L284.186 79.6129L252.532 130.129L252.188 130.337L284.029 79.7026Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M284.027 79.7027L283.876 79.6144L252.047 130.254L252.186 130.337L284.027 79.7027Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M251.575 60.9501L251.708 61.0294L219.723 111.128L219.52 111.206L251.575 60.9501Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M251.63 60.763L251.405 60.6322L219.269 111.06L219.519 111.206L251.63 60.763Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M219.789 110.919L219.59 110.974L252.095 130.097L252.136 129.967L219.789 110.919Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M219.592 110.974L219.52 111.206L252.048 130.255L252.097 130.097L219.592 110.974Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M285.79 79.178L286.966 80.7952L254.889 134.106L253.704 132.501L285.79 79.178Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M253.712 132.49L254.888 134.106L219.627 113.542L218.013 111.815L253.712 132.49Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M307.387 156.16L291.575 157.855L257.275 138.277L299.842 111.308L342.494 135.834L307.387 156.16Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M282.648 144.345C282.648 146.644 279.285 148.508 275.138 148.508C270.99 148.508 267.628 146.644 267.628 144.345C267.628 142.046 270.99 140.182 275.138 140.182C279.285 140.182 282.648 142.046 282.648 144.345Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M282.642 144.211C282.644 144.255 282.648 144.301 282.648 144.345C282.648 146.644 279.286 148.508 275.138 148.508C270.991 148.508 267.628 146.644 267.628 144.345V146.391H267.633C267.746 148.636 271.062 150.436 275.138 150.436C279.286 150.436 282.648 148.572 282.648 146.273V144.211H282.642Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M286.848 79.4669L321.479 99.5842L289.393 152.904L253.704 132.217L286.848 79.4669Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M287.319 81.1094L319.718 100.107L287.877 150.448L255.469 131.323L287.319 81.1094Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M313.994 106.58L308.752 103.522C308.228 103.217 307.499 102.202 308.266 101.134L311.065 96.7212C311.372 96.2562 312.327 96.0872 312.852 96.393L318.409 99.6093C318.933 99.9151 319.191 100.497 319.021 101.07L315.915 105.966C315.425 106.656 314.519 106.886 313.994 106.58Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M305.859 101.863L300.618 98.8053C300.094 98.4995 299.365 97.485 300.132 96.4159L302.931 92.0041C303.237 91.5391 304.193 91.3701 304.717 91.6759L310.274 94.8922C310.798 95.198 311.057 95.7797 310.886 96.3531L307.78 101.249C307.29 101.939 306.384 102.169 305.859 101.863Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M309.33 113.643L304.089 110.585C303.565 110.28 302.836 109.265 303.603 108.197L306.402 103.784C306.708 103.319 307.664 103.15 308.189 103.456L313.745 106.672C314.269 106.978 314.528 107.56 314.357 108.133L311.252 113.029C310.761 113.72 309.855 113.949 309.33 113.643Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M301.168 108.954L295.926 105.897C295.402 105.591 294.673 104.576 295.44 103.508L298.24 99.0954C298.546 98.6303 299.502 98.4614 300.026 98.7672L305.584 101.983C306.108 102.289 306.366 102.872 306.195 103.444L303.089 108.34C302.599 109.031 301.693 109.26 301.168 108.954Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M297.742 97.1212L292.5 94.0634C291.975 93.7576 291.246 92.7431 292.014 91.6739L294.813 87.2622C295.12 86.7971 296.075 86.6282 296.599 86.934L302.157 90.1503C302.681 90.4561 302.939 91.0377 302.768 91.6111L299.662 96.5066C299.173 97.1974 298.266 97.427 297.742 97.1212Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M289.61 92.4037L284.368 89.3466C283.844 89.0401 283.115 88.0256 283.882 86.9572L286.681 82.5447C286.988 82.0797 287.944 81.9107 288.468 82.2172L294.025 85.4335C294.549 85.7386 294.808 86.321 294.636 86.8936L291.531 91.7891C291.041 92.4807 290.134 92.7095 289.61 92.4037Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M293.078 104.185L287.837 101.127C287.312 100.821 286.584 99.8065 287.351 98.7381L290.15 94.3256C290.456 93.8606 291.412 93.6916 291.936 93.9974L297.493 97.2137C298.017 97.5195 298.276 98.1011 298.105 98.6746L295 103.57C294.509 104.261 293.603 104.49 293.078 104.185Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M284.916 99.496L279.674 96.4389C279.149 96.1324 278.421 95.1179 279.188 94.0495L281.987 89.637C282.294 89.172 283.249 89.003 283.773 89.3088L289.331 92.5251C289.855 92.8309 290.113 93.4125 289.942 93.986L286.836 98.8814C286.347 99.5722 285.44 99.8018 284.916 99.496Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M304.796 120.815L299.553 117.757C299.029 117.451 298.3 116.437 299.067 115.369L301.867 110.956C302.174 110.491 303.129 110.322 303.653 110.628L309.21 113.844C309.735 114.15 309.992 114.732 309.821 115.305L306.716 120.2C306.226 120.891 305.32 121.121 304.796 120.815Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M296.665 116.098L291.423 113.04C290.899 112.734 290.17 111.719 290.937 110.65L293.736 106.239C294.043 105.774 294.998 105.605 295.522 105.91L301.079 109.127C301.603 109.432 301.862 110.014 301.692 110.588L298.586 115.483C298.096 116.174 297.189 116.403 296.665 116.098Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M300.255 128.032L295.014 124.974C294.489 124.668 293.76 123.654 294.528 122.586L297.327 118.173C297.633 117.708 298.589 117.539 299.113 117.845L304.671 121.061C305.195 121.367 305.453 121.949 305.281 122.522L302.176 127.417C301.686 128.108 300.779 128.338 300.255 128.032Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M292.078 123.377L286.836 120.319C286.312 120.014 285.583 118.999 286.35 117.93L289.15 113.518C289.456 113.053 290.412 112.884 290.936 113.19L296.493 116.406C297.017 116.712 297.276 117.294 297.104 117.867L293.999 122.763C293.509 123.453 292.602 123.683 292.078 123.377Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M288.539 111.356L283.298 108.298C282.774 107.992 282.045 106.978 282.812 105.909L285.611 101.497C285.917 101.032 286.873 100.863 287.397 101.169L292.954 104.385C293.478 104.691 293.737 105.273 293.566 105.846L290.461 110.741C289.97 111.432 289.063 111.662 288.539 111.356Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M280.408 106.638L275.167 103.581C274.643 103.275 273.914 102.26 274.681 101.192L277.48 96.7794C277.787 96.3144 278.742 96.1454 279.266 96.452L284.824 99.6683C285.348 99.974 285.606 100.556 285.436 101.128L282.33 106.024C281.839 106.715 280.933 106.944 280.408 106.638Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M283.877 118.548L278.636 115.491C278.112 115.185 277.383 114.17 278.15 113.102L280.949 108.689C281.255 108.224 282.211 108.055 282.735 108.361L288.292 111.577C288.816 111.883 289.075 112.466 288.904 113.038L285.799 117.934C285.308 118.624 284.402 118.854 283.877 118.548Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M275.716 113.867L270.474 110.809C269.95 110.503 269.221 109.489 269.989 108.42L272.788 104.008C273.094 103.543 274.05 103.374 274.574 103.68L280.132 106.896C280.656 107.202 280.914 107.783 280.743 108.357L277.638 113.252C277.147 113.943 276.241 114.173 275.716 113.867Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M295.834 135.209L290.592 132.151C290.068 131.845 289.339 130.831 290.106 129.762L292.905 125.35C293.212 124.885 294.167 124.716 294.691 125.022L300.248 128.238C300.772 128.544 301.031 129.125 300.861 129.699L297.755 134.594C297.265 135.285 296.358 135.515 295.834 135.209Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M287.701 130.492L282.459 127.435C281.935 127.128 281.206 126.114 281.973 125.045L284.772 120.633C285.079 120.168 286.034 119.999 286.558 120.305L292.115 123.522C292.64 123.827 292.898 124.409 292.728 124.982L289.622 129.877C289.132 130.568 288.226 130.798 287.701 130.492Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M291.172 142.273L285.931 139.215C285.407 138.909 284.678 137.894 285.445 136.826L288.244 132.414C288.55 131.949 289.506 131.78 290.03 132.085L295.587 135.302C296.111 135.607 296.37 136.189 296.199 136.763L293.093 141.658C292.603 142.349 291.696 142.578 291.172 142.273Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M283.009 137.583L277.767 134.526C277.243 134.22 276.514 133.205 277.281 132.137L280.081 127.724C280.387 127.259 281.343 127.09 281.867 127.396L287.425 130.612C287.949 130.918 288.207 131.5 288.036 132.073L284.93 136.969C284.44 137.66 283.534 137.889 283.009 137.583Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M279.578 125.749L274.336 122.692C273.812 122.386 273.083 121.371 273.85 120.303L276.65 115.89C276.956 115.425 277.912 115.256 278.436 115.563L283.993 118.779C284.517 119.084 284.776 119.667 284.604 120.239L281.499 125.135C281.009 125.826 280.102 126.055 279.578 125.749Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M271.448 121.033L266.207 117.976C265.682 117.669 264.954 116.655 265.721 115.586L268.52 111.174C268.826 110.709 269.782 110.54 270.306 110.846L275.863 114.062C276.387 114.368 276.646 114.949 276.475 115.523L273.369 120.418C272.879 121.109 271.972 121.339 271.448 121.033Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M274.92 132.814L269.678 129.757C269.154 129.45 268.425 128.436 269.192 127.367L271.991 122.955C272.298 122.49 273.253 122.321 273.778 122.627L279.335 125.844C279.859 126.149 280.117 126.731 279.947 127.304L276.841 132.199C276.351 132.891 275.445 133.12 274.92 132.814Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M266.756 128.125L261.515 125.067C260.991 124.761 260.262 123.747 261.029 122.678L263.828 118.266C264.134 117.801 265.09 117.632 265.614 117.938L271.172 121.154C271.696 121.46 271.954 122.042 271.783 122.615L268.678 127.51C268.187 128.201 267.28 128.431 266.756 128.125Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M286.491 149.404L281.249 146.347C280.725 146.041 279.996 145.026 280.763 143.958L283.562 139.545C283.869 139.08 284.824 138.911 285.348 139.218L290.905 142.434C291.429 142.74 291.688 143.321 291.518 143.894L288.412 148.79C287.921 149.481 287.015 149.71 286.491 149.404Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M278.329 144.715L273.087 141.657C272.562 141.351 271.834 140.337 272.601 139.267L275.4 134.856C275.707 134.391 276.662 134.222 277.186 134.527L282.744 137.744C283.268 138.05 283.526 138.631 283.355 139.205L280.249 144.1C279.76 144.791 278.853 145.02 278.329 144.715Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M270.239 139.945L264.998 136.888C264.474 136.581 263.745 135.567 264.512 134.498L267.311 130.086C267.617 129.621 268.573 129.452 269.097 129.757L274.654 132.974C275.178 133.28 275.437 133.862 275.266 134.435L272.16 139.33C271.67 140.021 270.763 140.25 270.239 139.945Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M262.075 135.256L256.833 132.198C256.309 131.892 255.58 130.878 256.347 129.809L259.147 125.397C259.453 124.932 260.409 124.763 260.933 125.069L266.49 128.285C267.015 128.591 267.273 129.172 267.102 129.746L263.996 134.641C263.506 135.332 262.6 135.562 262.075 135.256Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M289.839 82.8115L258.622 133.134L289.839 82.8115Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M289.839 82.8115L258.622 133.134L289.839 82.8115Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M291.87 84.0668L260.654 134.39L291.87 84.0668Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M291.87 84.0668L260.654 134.39L291.87 84.0668Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M297.859 87.6047L266.643 137.928L297.859 87.6047Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M297.859 87.6047L266.643 137.928L297.859 87.6047Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M299.891 88.861L268.675 139.184L299.891 88.861Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M299.891 88.861L268.675 139.184L299.891 88.861Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M305.881 92.2858L274.664 142.609L305.881 92.2858Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M305.881 92.2858L274.664 142.609L305.881 92.2858Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M307.914 93.5407L276.697 143.864L307.914 93.5407Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M307.914 93.5407L276.697 143.864L307.914 93.5407Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M313.902 96.9661L282.686 147.289L313.902 96.9661Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M313.902 96.9661L282.686 147.289L313.902 96.9661Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M315.936 98.2217L284.719 148.545L315.936 98.2217Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M315.936 98.2217L284.719 148.545L315.936 98.2217Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M287.265 80.9462L287.094 81.0374L319.721 100.106L319.877 100.015L287.265 80.9462Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M287.092 81.0365L287.037 81.2234L319.509 100.141L319.537 100.017L287.092 81.0365Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M319.719 100.106L319.875 100.015L288.221 150.532L287.877 150.739L319.719 100.106Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M319.72 100.105L319.569 100.017L287.739 150.657L287.879 150.739L319.72 100.105Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M287.267 81.3523L287.401 81.4315L255.416 131.53L255.213 131.608L287.267 81.3523Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M287.32 81.1651L287.095 81.0335L254.958 131.461L255.209 131.608L287.32 81.1651Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M255.48 131.321L255.281 131.376L287.786 150.499L287.827 150.369L255.48 131.321Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M255.284 131.376L255.213 131.607L287.741 150.657L287.79 150.499L255.284 131.376Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M321.474 99.5802L322.65 101.197L290.573 154.509L289.388 152.903L321.474 99.5802Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M289.403 152.892L290.579 154.508L255.32 133.943L253.704 132.217L289.403 152.892Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M214.434 164.543L198.622 166.238L164.322 146.66L206.89 119.691L249.541 144.217L214.434 164.543Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M189.697 152.729C189.697 155.028 186.333 156.891 182.186 156.891C178.038 156.891 174.676 155.028 174.676 152.729C174.676 150.43 178.038 148.566 182.186 148.566C186.333 148.566 189.697 150.43 189.697 152.729Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M189.691 152.595C189.693 152.639 189.697 152.685 189.697 152.729C189.697 155.028 186.335 156.892 182.187 156.892C178.039 156.892 174.676 155.028 174.676 152.729V154.775H174.682C174.795 157.02 178.11 158.82 182.187 158.82C186.335 158.82 189.697 156.956 189.697 154.657V152.595H189.691Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M193.895 87.8508L228.526 107.968L196.44 161.288L160.751 140.601L193.895 87.8508Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M194.368 89.4933L226.765 108.491L194.925 158.831L162.518 139.707L194.368 89.4933Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M221.041 114.963L215.799 111.906C215.275 111.6 214.546 110.585 215.313 109.517L218.112 105.104C218.419 104.639 219.374 104.47 219.898 104.776L225.456 107.993C225.98 108.298 226.238 108.88 226.068 109.453L222.962 114.349C222.472 115.04 221.565 115.269 221.041 114.963Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M212.908 110.246L207.666 107.189C207.142 106.883 206.413 105.868 207.18 104.799L209.98 100.387C210.286 99.9224 211.242 99.7534 211.766 100.059L217.324 103.276C217.848 103.581 218.106 104.163 217.935 104.736L214.829 109.632C214.339 110.323 213.433 110.552 212.908 110.246Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M216.372 122.028L211.13 118.971C210.606 118.664 209.877 117.65 210.645 116.581L213.444 112.169C213.75 111.704 214.706 111.535 215.23 111.841L220.788 115.057C221.312 115.363 221.57 115.944 221.399 116.518L218.294 121.413C217.803 122.104 216.897 122.334 216.372 122.028Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M208.215 117.338L202.973 114.281C202.449 113.975 201.72 112.96 202.487 111.892L205.287 107.479C205.593 107.014 206.549 106.845 207.073 107.151L212.63 110.368C213.154 110.673 213.413 111.255 213.241 111.828L210.136 116.724C209.646 117.414 208.739 117.644 208.215 117.338Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M204.783 105.505L199.541 102.448C199.017 102.142 198.288 101.127 199.055 100.059L201.855 95.6465C202.161 95.1814 203.117 95.0125 203.641 95.3182L209.199 98.5345C209.723 98.8403 209.981 99.422 209.81 99.9954L206.704 104.891C206.214 105.582 205.307 105.811 204.783 105.505Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M196.655 100.788L191.414 97.7299C190.89 97.4242 190.161 96.4096 190.928 95.3405L193.727 90.9287C194.033 90.4637 194.989 90.2947 195.513 90.6005L201.071 93.8168C201.595 94.1226 201.853 94.7043 201.682 95.2777L198.577 100.173C198.086 100.864 197.179 101.094 196.655 100.788Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M200.126 112.569L194.885 109.511C194.36 109.205 193.632 108.19 194.399 107.122L197.198 102.71C197.504 102.244 198.46 102.076 198.984 102.381L204.541 105.598C205.065 105.903 205.324 106.485 205.152 107.058L202.047 111.954C201.557 112.645 200.65 112.874 200.126 112.569Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M191.964 107.88L186.722 104.822C186.198 104.516 185.469 103.501 186.236 102.433L189.035 98.0205C189.342 97.5555 190.297 97.3865 190.822 97.6923L196.379 100.909C196.903 101.214 197.161 101.796 196.991 102.37L193.885 107.265C193.395 107.956 192.489 108.185 191.964 107.88Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M211.842 129.198L206.6 126.141C206.076 125.835 205.347 124.82 206.114 123.752L208.914 119.339C209.22 118.874 210.176 118.705 210.7 119.011L216.257 122.227C216.781 122.533 217.04 123.115 216.868 123.688L213.763 128.584C213.273 129.275 212.366 129.504 211.842 129.198Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M203.713 124.481L198.471 121.424C197.946 121.118 197.218 120.103 197.985 119.035L200.784 114.622C201.091 114.157 202.046 113.988 202.57 114.294L208.128 117.511C208.652 117.816 208.91 118.398 208.739 118.971L205.634 123.867C205.144 124.558 204.237 124.787 203.713 124.481Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M207.301 136.416L202.059 133.358C201.535 133.052 200.806 132.037 201.573 130.969L204.372 126.557C204.679 126.092 205.634 125.923 206.158 126.228L211.715 129.445C212.239 129.75 212.498 130.332 212.328 130.906L209.222 135.801C208.732 136.492 207.825 136.721 207.301 136.416Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M199.12 131.761L193.878 128.703C193.354 128.398 192.625 127.383 193.392 126.315L196.191 121.902C196.498 121.437 197.453 121.268 197.978 121.574L203.535 124.79C204.06 125.096 204.317 125.678 204.147 126.251L201.041 131.147C200.551 131.837 199.645 132.067 199.12 131.761Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M195.588 119.74L190.346 116.682C189.822 116.376 189.093 115.362 189.86 114.293L192.659 109.881C192.966 109.416 193.921 109.247 194.445 109.553L200.002 112.769C200.527 113.075 200.785 113.656 200.615 114.23L197.509 119.125C197.019 119.816 196.113 120.046 195.588 119.74Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M187.46 115.023L182.219 111.966C181.695 111.66 180.966 110.645 181.733 109.576L184.532 105.164C184.839 104.699 185.794 104.53 186.318 104.836L191.875 108.052C192.399 108.358 192.658 108.94 192.488 109.513L189.382 114.409C188.891 115.1 187.985 115.329 187.46 115.023Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M190.925 126.932L185.684 123.875C185.16 123.569 184.431 122.554 185.198 121.486L187.997 117.073C188.303 116.608 189.259 116.439 189.783 116.746L195.34 119.962C195.864 120.268 196.123 120.85 195.952 121.422L192.847 126.318C192.356 127.009 191.45 127.238 190.925 126.932Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M182.765 122.251L177.523 119.194C176.999 118.888 176.27 117.873 177.037 116.804L179.836 112.392C180.143 111.927 181.098 111.758 181.622 112.064L187.179 115.281C187.704 115.586 187.962 116.168 187.792 116.741L184.686 121.637C184.196 122.328 183.289 122.557 182.765 122.251Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M202.882 143.592L197.64 140.534C197.116 140.228 196.387 139.214 197.154 138.145L199.954 133.733C200.26 133.268 201.216 133.099 201.74 133.405L207.298 136.621C207.822 136.927 208.08 137.508 207.908 138.082L204.803 142.977C204.313 143.668 203.406 143.898 202.882 143.592Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M194.751 138.876L189.509 135.818C188.984 135.512 188.256 134.497 189.023 133.429L191.822 129.017C192.129 128.552 193.084 128.383 193.608 128.689L199.166 131.905C199.69 132.211 199.948 132.793 199.777 133.366L196.671 138.261C196.182 138.953 195.275 139.181 194.751 138.876Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M198.214 150.657L192.973 147.599C192.449 147.293 191.72 146.279 192.487 145.21L195.286 140.798C195.592 140.333 196.548 140.164 197.072 140.47L202.63 143.686C203.154 143.992 203.412 144.573 203.241 145.147L200.136 150.042C199.645 150.733 198.739 150.963 198.214 150.657Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M190.057 145.967L184.816 142.909C184.292 142.604 183.563 141.589 184.33 140.521L187.129 136.108C187.435 135.643 188.391 135.474 188.915 135.78L194.472 138.996C194.996 139.302 195.255 139.884 195.084 140.457L191.978 145.353C191.488 146.044 190.582 146.273 190.057 145.967Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M186.63 134.133L181.388 131.076C180.864 130.769 180.135 129.755 180.902 128.686L183.701 124.274C184.008 123.809 184.963 123.64 185.487 123.946L191.045 127.163C191.569 127.468 191.827 128.05 191.657 128.623L188.551 133.518C188.061 134.21 187.155 134.438 186.63 134.133Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M178.499 129.417L173.257 126.359C172.733 126.053 172.004 125.038 172.771 123.97L175.571 119.558C175.877 119.092 176.833 118.924 177.357 119.229L182.915 122.446C183.439 122.751 183.697 123.333 183.526 123.906L180.42 128.802C179.93 129.493 179.024 129.722 178.499 129.417Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M181.962 141.197L176.721 138.139C176.196 137.834 175.468 136.819 176.235 135.75L179.034 131.338C179.34 130.873 180.296 130.704 180.82 131.01L186.378 134.226C186.902 134.532 187.16 135.114 186.989 135.687L183.883 140.583C183.393 141.273 182.486 141.503 181.962 141.197Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M173.805 136.509L168.563 133.451C168.039 133.145 167.31 132.131 168.077 131.062L170.877 126.65C171.183 126.185 172.139 126.016 172.663 126.321L178.22 129.538C178.744 129.844 179.002 130.425 178.832 130.999L175.726 135.894C175.236 136.585 174.33 136.814 173.805 136.509Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M193.539 157.788L188.297 154.731C187.773 154.425 187.044 153.41 187.811 152.341L190.611 147.929C190.917 147.464 191.873 147.295 192.397 147.601L197.954 150.818C198.478 151.123 198.737 151.705 198.565 152.278L195.46 157.174C194.97 157.865 194.063 158.094 193.539 157.788Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M185.375 153.098L180.133 150.041C179.609 149.735 178.88 148.72 179.647 147.652L182.447 143.239C182.753 142.774 183.709 142.605 184.233 142.911L189.79 146.127C190.314 146.433 190.573 147.015 190.402 147.588L187.296 152.484C186.806 153.175 185.9 153.404 185.375 153.098Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M177.281 148.329L172.04 145.272C171.516 144.965 170.787 143.951 171.554 142.882L174.353 138.47C174.659 138.005 175.615 137.836 176.139 138.141L181.697 141.358C182.221 141.664 182.479 142.246 182.308 142.819L179.203 147.714C178.712 148.405 177.806 148.634 177.281 148.329Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M169.124 143.639L163.882 140.582C163.358 140.276 162.629 139.261 163.396 138.192L166.196 133.78C166.502 133.315 167.458 133.146 167.982 133.452L173.539 136.669C174.063 136.974 174.322 137.556 174.15 138.129L171.045 143.025C170.555 143.716 169.648 143.945 169.124 143.639Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M196.883 91.1957L165.667 141.519L196.883 91.1957Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M196.883 91.1957L165.667 141.519L196.883 91.1957Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M198.913 92.4504L167.697 142.773L198.913 92.4504Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M198.913 92.4504L167.697 142.773L198.913 92.4504Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M204.906 95.989L173.689 146.312L204.906 95.989Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M204.906 95.989L173.689 146.312L204.906 95.989Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M206.938 97.2446L175.722 147.568L206.938 97.2446Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M206.938 97.2446L175.722 147.568L206.938 97.2446Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M212.928 100.67L181.711 150.993L212.928 100.67Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M212.928 100.67L181.711 150.993L212.928 100.67Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M214.958 101.925L183.742 152.248L214.958 101.925Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M214.958 101.925L183.742 152.248L214.958 101.925Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M220.945 105.35L189.729 155.673L220.945 105.35Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M220.945 105.35L189.729 155.673L220.945 105.35Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M222.984 106.605L191.768 156.928L222.984 106.605Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M222.984 106.605L191.768 156.928L222.984 106.605Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M194.307 89.3301L194.136 89.4213L226.763 108.49L226.919 108.398L194.307 89.3301Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M194.139 89.4203L194.084 89.6073L226.556 108.524L226.584 108.4L194.139 89.4203Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M226.761 108.489L226.918 108.399L195.264 158.915L194.92 159.123L226.761 108.489Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M226.764 108.489L226.613 108.401L194.783 159.04L194.923 159.123L226.764 108.489Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M194.309 89.736L194.443 89.8152L162.458 139.914L162.254 139.992L194.309 89.736Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M194.368 89.5496L194.142 89.418L162.006 139.846L162.256 139.992L194.368 89.5496Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M162.526 139.704L162.327 139.76L194.833 158.883L194.874 158.753L162.526 139.704Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M162.326 139.76L162.254 139.992L194.782 159.042L194.831 158.883L162.326 139.76Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M228.525 107.964L229.701 109.581L197.623 162.892L196.438 161.287L228.525 107.964Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M196.45 161.276L197.626 162.892L162.365 142.327L160.751 140.601L196.45 161.276Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M251.388 186.794L235.577 188.489L201.276 168.911L243.844 141.941L286.495 166.467L251.388 186.794Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M226.649 174.977C226.649 177.276 223.286 179.14 219.139 179.14C214.992 179.14 211.629 177.276 211.629 174.977C211.629 172.678 214.992 170.814 219.139 170.814C223.286 170.814 226.649 172.678 226.649 174.977Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M226.643 174.844C226.646 174.888 226.649 174.933 226.649 174.978C226.649 177.277 223.286 179.141 219.139 179.141C214.991 179.141 211.629 177.277 211.629 174.978V177.024H211.635C211.748 179.268 215.062 181.069 219.139 181.069C223.286 181.069 226.649 179.205 226.649 176.906V174.844H226.643Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M230.844 110.099L265.475 130.217L233.389 183.536L197.7 162.85L230.844 110.099Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M231.318 111.743L263.716 130.74L231.875 181.081L199.468 161.956L231.318 111.743Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M257.991 137.213L252.75 134.155C252.226 133.849 251.497 132.835 252.264 131.766L255.063 127.354C255.369 126.889 256.325 126.72 256.849 127.026L262.407 130.242C262.931 130.548 263.189 131.129 263.018 131.703L259.913 136.598C259.422 137.289 258.516 137.519 257.991 137.213Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M249.858 132.496L244.616 129.439C244.092 129.133 243.363 128.118 244.13 127.05L246.929 122.637C247.236 122.172 248.191 122.003 248.716 122.31L254.273 125.526C254.797 125.832 255.055 126.413 254.885 126.986L251.779 131.882C251.289 132.573 250.383 132.802 249.858 132.496Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M253.329 144.277L248.087 141.22C247.563 140.914 246.834 139.899 247.601 138.831L250.4 134.418C250.707 133.953 251.662 133.784 252.187 134.09L257.744 137.307C258.268 137.612 258.526 138.194 258.356 138.767L255.25 143.663C254.76 144.354 253.854 144.583 253.329 144.277Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M245.167 139.588L239.925 136.53C239.4 136.224 238.672 135.209 239.439 134.141L242.238 129.729C242.545 129.264 243.5 129.095 244.025 129.4L249.582 132.617C250.107 132.922 250.364 133.504 250.193 134.078L247.088 138.973C246.598 139.664 245.691 139.893 245.167 139.588Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M241.737 127.754L236.496 124.696C235.972 124.39 235.243 123.376 236.01 122.307L238.809 117.895C239.115 117.43 240.071 117.261 240.595 117.567L246.152 120.783C246.676 121.089 246.935 121.67 246.764 122.244L243.659 127.139C243.168 127.83 242.262 128.06 241.737 127.754Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M233.604 123.037L228.363 119.98C227.839 119.673 227.11 118.659 227.877 117.591L230.676 113.178C230.982 112.713 231.938 112.544 232.462 112.85L238.019 116.066C238.543 116.372 238.802 116.954 238.631 117.527L235.526 122.422C235.035 123.113 234.129 123.343 233.604 123.037Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M237.077 134.819L231.835 131.761C231.31 131.455 230.582 130.44 231.349 129.371L234.148 124.96C234.455 124.494 235.41 124.326 235.934 124.631L241.491 127.848C242.015 128.153 242.274 128.735 242.103 129.308L238.997 134.204C238.508 134.895 237.601 135.124 237.077 134.819Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M228.913 130.129L223.671 127.071C223.147 126.766 222.418 125.751 223.185 124.683L225.984 120.27C226.291 119.805 227.246 119.636 227.771 119.942L233.328 123.158C233.852 123.464 234.11 124.046 233.94 124.619L230.834 129.515C230.344 130.206 229.438 130.435 228.913 130.129Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M248.796 151.447L243.555 148.39C243.031 148.084 242.302 147.069 243.069 146.001L245.868 141.588C246.174 141.123 247.13 140.954 247.654 141.26L253.211 144.476C253.735 144.782 253.994 145.364 253.823 145.937L250.718 150.833C250.227 151.524 249.321 151.753 248.796 151.447Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M240.663 146.731L235.421 143.673C234.897 143.367 234.168 142.353 234.935 141.284L237.734 136.872C238.041 136.407 238.996 136.238 239.521 136.544L245.078 139.76C245.602 140.066 245.86 140.647 245.69 141.221L242.584 146.116C242.094 146.807 241.187 147.037 240.663 146.731Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M244.258 158.665L239.016 155.607C238.492 155.302 237.763 154.287 238.53 153.219L241.329 148.806C241.636 148.341 242.591 148.172 243.115 148.478L248.672 151.694C249.196 152 249.455 152.582 249.285 153.155L246.179 158.051C245.689 158.741 244.782 158.971 244.258 158.665Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M236.074 154.01L230.833 150.952C230.309 150.646 229.58 149.632 230.347 148.563L233.146 144.151C233.452 143.686 234.408 143.517 234.932 143.823L240.489 147.039C241.013 147.345 241.272 147.927 241.101 148.5L237.996 153.395C237.505 154.086 236.599 154.316 236.074 154.01Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M232.539 141.988L227.298 138.931C226.774 138.625 226.045 137.61 226.812 136.541L229.611 132.129C229.917 131.664 230.873 131.495 231.397 131.801L236.954 135.017C237.478 135.323 237.737 135.905 237.566 136.478L234.461 141.374C233.97 142.065 233.064 142.294 232.539 141.988Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M224.41 137.272L219.169 134.215C218.645 133.908 217.916 132.893 218.683 131.825L221.482 127.413C221.789 126.948 222.744 126.779 223.268 127.084L228.825 130.301C229.349 130.606 229.608 131.189 229.438 131.762L226.332 136.657C225.841 137.348 224.935 137.577 224.41 137.272Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M227.878 149.181L222.636 146.124C222.112 145.818 221.383 144.803 222.151 143.735L224.95 139.322C225.256 138.857 226.212 138.688 226.736 138.994L232.293 142.21C232.817 142.516 233.076 143.098 232.904 143.671L229.799 148.567C229.309 149.257 228.402 149.487 227.878 149.181Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M219.722 144.5L214.48 141.443C213.956 141.136 213.227 140.122 213.994 139.053L216.793 134.641C217.1 134.176 218.055 134.007 218.579 134.313L224.137 137.529C224.661 137.835 224.919 138.417 224.749 138.99L221.643 143.885C221.153 144.576 220.247 144.806 219.722 144.5Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M239.831 165.842L234.59 162.785C234.065 162.478 233.337 161.464 234.104 160.395L236.903 155.983C237.209 155.518 238.165 155.349 238.689 155.656L244.246 158.872C244.77 159.177 245.029 159.759 244.858 160.332L241.752 165.227C241.262 165.919 240.355 166.148 239.831 165.842Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M231.706 161.125L226.464 158.068C225.94 157.761 225.211 156.747 225.978 155.679L228.778 151.266C229.084 150.801 230.04 150.632 230.564 150.938L236.121 154.154C236.645 154.46 236.904 155.042 236.732 155.615L233.627 160.511C233.137 161.201 232.23 161.431 231.706 161.125Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M235.17 172.906L229.928 169.848C229.404 169.543 228.675 168.528 229.442 167.459L232.241 163.047C232.548 162.582 233.503 162.413 234.028 162.719L239.585 165.935C240.109 166.241 240.367 166.823 240.197 167.396L237.091 172.292C236.601 172.982 235.695 173.212 235.17 172.906Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M227.007 168.216L221.765 165.158C221.241 164.852 220.512 163.838 221.279 162.77L224.078 158.357C224.385 157.892 225.34 157.723 225.864 158.029L231.422 161.245C231.946 161.551 232.204 162.133 232.034 162.706L228.928 167.601C228.438 168.292 227.531 168.522 227.007 168.216Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M223.582 156.383L218.341 153.326C217.817 153.019 217.088 152.005 217.855 150.936L220.654 146.524C220.96 146.059 221.916 145.89 222.44 146.196L227.997 149.412C228.521 149.718 228.78 150.299 228.609 150.873L225.504 155.768C225.013 156.459 224.107 156.689 223.582 156.383Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M215.452 151.666L210.211 148.608C209.687 148.302 208.958 147.288 209.725 146.219L212.524 141.807C212.83 141.342 213.786 141.173 214.31 141.479L219.867 144.695C220.391 145.001 220.65 145.582 220.48 146.156L217.374 151.051C216.883 151.742 215.977 151.972 215.452 151.666Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M218.917 163.447L213.676 160.39C213.152 160.084 212.423 159.069 213.19 158.001L215.989 153.588C216.295 153.123 217.251 152.954 217.775 153.26L223.332 156.477C223.856 156.782 224.115 157.365 223.944 157.937L220.839 162.833C220.348 163.524 219.441 163.753 218.917 163.447Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M210.757 158.758L205.515 155.7C204.991 155.395 204.262 154.38 205.029 153.311L207.828 148.899C208.135 148.434 209.09 148.265 209.614 148.571L215.171 151.787C215.695 152.093 215.954 152.675 215.784 153.248L212.678 158.144C212.188 158.835 211.281 159.064 210.757 158.758Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M230.489 180.037L225.248 176.98C224.723 176.674 223.995 175.659 224.762 174.591L227.561 170.178C227.868 169.713 228.823 169.544 229.347 169.85L234.904 173.066C235.428 173.372 235.687 173.954 235.516 174.527L232.41 179.423C231.92 180.113 231.014 180.343 230.489 180.037Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M222.333 175.348L217.091 172.29C216.567 171.984 215.838 170.969 216.605 169.9L219.404 165.489C219.711 165.024 220.666 164.855 221.19 165.16L226.747 168.377C227.271 168.682 227.53 169.264 227.36 169.838L224.254 174.733C223.764 175.424 222.857 175.653 222.333 175.348Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M214.237 170.579L208.995 167.521C208.471 167.215 207.742 166.2 208.509 165.132L211.308 160.72C211.615 160.255 212.57 160.086 213.094 160.391L218.651 163.608C219.175 163.913 219.434 164.495 219.264 165.069L216.158 169.964C215.668 170.655 214.761 170.884 214.237 170.579Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M206.076 165.889L200.834 162.832C200.31 162.525 199.581 161.511 200.348 160.442L203.147 156.03C203.454 155.565 204.409 155.396 204.933 155.701L210.491 158.918C211.015 159.224 211.273 159.806 211.102 160.379L207.996 165.274C207.507 165.965 206.6 166.194 206.076 165.889Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M233.836 113.445L202.619 163.768L233.836 113.445Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M233.836 113.445L202.619 163.768L233.836 113.445Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M235.866 114.7L204.65 165.023L235.866 114.7Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M235.866 114.7L204.65 165.023L235.866 114.7Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M241.856 118.239L210.639 168.562L241.856 118.239Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M241.856 118.239L210.639 168.562L241.856 118.239Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M243.887 119.493L212.671 169.816L243.887 119.493Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M243.887 119.493L212.671 169.816L243.887 119.493Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M249.881 122.919L218.665 173.242L249.881 122.919Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M249.881 122.919L218.665 173.242L249.881 122.919Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M251.911 124.175L220.694 174.498L251.911 124.175Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M251.911 124.175L220.694 174.498L251.911 124.175Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M257.901 127.599L226.684 177.922L257.901 127.599Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M257.901 127.599L226.684 177.922L257.901 127.599Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M259.933 128.854L228.717 179.177L259.933 128.854Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M259.933 128.854L228.717 179.177L259.933 128.854Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M231.264 111.579L231.093 111.671L263.72 130.74L263.875 130.648L231.264 111.579Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M231.092 111.669L231.037 111.856L263.508 130.774L263.537 130.65L231.092 111.669Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M263.719 130.738L263.875 130.648L232.221 181.165L231.877 181.372L263.719 130.738Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M263.713 130.738L263.562 130.65L231.732 181.29L231.871 181.372L263.713 130.738Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M231.264 111.986L231.398 112.065L199.413 162.164L199.21 162.241L231.264 111.986Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M231.316 111.798L231.091 111.666L198.954 162.093L199.205 162.241L231.316 111.798Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M199.478 161.954L199.279 162.009L231.785 181.132L231.826 181.002L199.478 161.954Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M199.281 162.01L199.21 162.241L231.738 181.291L231.787 181.132L199.281 162.01Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M265.479 130.214L266.655 131.83L234.578 185.142L233.393 183.536L265.479 130.214Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M233.399 183.525L234.575 185.141L199.314 164.577L197.7 162.85L233.399 183.525Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M343.312 176.928L327.5 178.622L293.2 159.044L335.767 132.075L378.419 156.601L343.312 176.928Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M318.573 165.113C318.573 167.412 315.211 169.276 311.063 169.276C306.915 169.276 303.553 167.412 303.553 165.113C303.553 162.814 306.915 160.95 311.063 160.95C315.211 160.95 318.573 162.814 318.573 165.113Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M318.57 164.979C318.573 165.023 318.577 165.069 318.577 165.113C318.577 167.412 315.214 169.276 311.066 169.276C306.918 169.276 303.556 167.412 303.556 165.113V167.159H303.561C303.674 169.404 306.99 171.204 311.066 171.204C315.214 171.204 318.577 169.34 318.577 167.041V164.979H318.57Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M322.769 100.234L357.4 120.351L325.314 173.671L289.625 152.985L322.769 100.234Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M323.241 101.877L355.638 120.874L323.798 171.215L291.391 152.09L323.241 101.877Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M349.916 127.348L344.674 124.29C344.149 123.984 343.42 122.97 344.188 121.901L346.986 117.489C347.294 117.024 348.249 116.855 348.773 117.161L354.331 120.377C354.855 120.683 355.113 121.264 354.943 121.838L351.836 126.733C351.347 127.424 350.44 127.654 349.916 127.348Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M341.782 122.631L336.54 119.573C336.016 119.267 335.287 118.253 336.055 117.184L338.853 112.772C339.16 112.307 340.115 112.138 340.64 112.443L346.196 115.66C346.72 115.966 346.979 116.547 346.809 117.121L343.703 122.016C343.213 122.707 342.306 122.936 341.782 122.631Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M345.253 134.412L340.011 131.355C339.487 131.049 338.758 130.034 339.526 128.966L342.324 124.553C342.632 124.088 343.587 123.919 344.111 124.225L349.668 127.441C350.193 127.747 350.451 128.329 350.281 128.902L347.174 133.798C346.684 134.489 345.778 134.718 345.253 134.412Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M337.091 129.723L331.849 126.666C331.325 126.359 330.596 125.344 331.364 124.276L334.162 119.864C334.468 119.399 335.425 119.23 335.949 119.536L341.505 122.752C342.029 123.057 342.287 123.64 342.117 124.213L339.012 129.108C338.521 129.8 337.615 130.028 337.091 129.723Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M333.666 117.889L328.423 114.831C327.899 114.525 327.17 113.511 327.938 112.442L330.737 108.03C331.044 107.565 331.999 107.396 332.523 107.702L338.081 110.918C338.605 111.224 338.863 111.805 338.693 112.379L335.586 117.274C335.096 117.965 334.19 118.195 333.666 117.889Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M325.535 113.172L320.293 110.114C319.769 109.808 319.04 108.794 319.807 107.724L322.606 103.313C322.913 102.848 323.868 102.679 324.393 102.984L329.95 106.201C330.474 106.507 330.732 107.088 330.562 107.662L327.456 112.557C326.966 113.248 326.06 113.477 325.535 113.172Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M328.999 124.953L323.757 121.896C323.233 121.59 322.504 120.575 323.271 119.507L326.07 115.094C326.376 114.629 327.333 114.46 327.857 114.766L333.413 117.983C333.938 118.288 334.195 118.87 334.025 119.443L330.92 124.339C330.429 125.03 329.523 125.259 328.999 124.953Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M320.839 120.263L315.598 117.206C315.074 116.9 314.345 115.885 315.112 114.817L317.911 110.404C318.217 109.939 319.173 109.77 319.698 110.076L325.255 113.292C325.779 113.598 326.037 114.18 325.866 114.753L322.761 119.649C322.27 120.34 321.364 120.569 320.839 120.263Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M340.72 141.583L335.479 138.525C334.955 138.219 334.226 137.205 334.993 136.136L337.792 131.724C338.098 131.259 339.054 131.09 339.578 131.396L345.135 134.612C345.659 134.918 345.918 135.499 345.747 136.073L342.641 140.968C342.151 141.659 341.244 141.889 340.72 141.583Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M332.587 136.866L327.345 133.808C326.821 133.502 326.092 132.488 326.86 131.42L329.658 127.007C329.965 126.542 330.921 126.373 331.445 126.679L337.001 129.895C337.526 130.201 337.783 130.783 337.613 131.356L334.508 136.251C334.018 136.942 333.112 137.172 332.587 136.866Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M336.181 148.799L330.939 145.741C330.414 145.436 329.686 144.421 330.453 143.353L333.252 138.94C333.559 138.475 334.515 138.306 335.039 138.612L340.596 141.828C341.121 142.134 341.378 142.716 341.208 143.289L338.102 148.185C337.611 148.875 336.705 149.105 336.181 148.799Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M327.993 144.145L322.751 141.087C322.227 140.781 321.498 139.767 322.266 138.698L325.064 134.286C325.372 133.821 326.327 133.652 326.851 133.958L332.409 137.174C332.933 137.48 333.191 138.061 333.021 138.635L329.914 143.53C329.424 144.221 328.518 144.451 327.993 144.145Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M324.469 132.124L319.227 129.066C318.703 128.76 317.974 127.746 318.741 126.677L321.54 122.265C321.847 121.8 322.803 121.631 323.327 121.937L328.885 125.153C329.409 125.459 329.667 126.04 329.496 126.614L326.39 131.509C325.9 132.2 324.993 132.43 324.469 132.124Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M316.337 127.407L311.095 124.349C310.571 124.043 309.842 123.029 310.61 121.96L313.408 117.548C313.715 117.083 314.67 116.914 315.195 117.22L320.751 120.436C321.276 120.742 321.534 121.323 321.364 121.897L318.258 126.792C317.768 127.483 316.862 127.713 316.337 127.407Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M319.802 139.316L314.56 136.259C314.035 135.952 313.306 134.937 314.074 133.869L316.873 129.457C317.18 128.992 318.135 128.823 318.659 129.129L324.217 132.345C324.741 132.651 324.999 133.233 324.829 133.806L321.722 138.701C321.233 139.393 320.326 139.621 319.802 139.316Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M311.643 134.635L306.401 131.577C305.877 131.271 305.148 130.257 305.916 129.188L308.714 124.776C309.021 124.311 309.977 124.142 310.501 124.448L316.058 127.664C316.583 127.97 316.841 128.551 316.67 129.125L313.564 134.02C313.073 134.711 312.167 134.941 311.643 134.635Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M331.756 155.976L326.514 152.919C325.99 152.613 325.261 151.598 326.029 150.53L328.827 146.117C329.134 145.652 330.09 145.483 330.614 145.789L336.17 149.006C336.695 149.311 336.952 149.893 336.782 150.466L333.677 155.362C333.187 156.053 332.28 156.282 331.756 155.976Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M323.629 151.259L318.387 148.202C317.862 147.896 317.134 146.881 317.901 145.813L320.7 141.4C321.007 140.935 321.962 140.766 322.486 141.073L328.043 144.289C328.567 144.595 328.826 145.177 328.656 145.749L325.549 150.645C325.06 151.336 324.153 151.565 323.629 151.259Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M327.094 163.041L321.852 159.984C321.328 159.678 320.599 158.663 321.366 157.595L324.165 153.182C324.472 152.717 325.427 152.548 325.952 152.854L331.508 156.07C332.032 156.376 332.291 156.958 332.121 157.531L329.015 162.427C328.525 163.118 327.618 163.347 327.094 163.041Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M318.937 158.352L313.696 155.294C313.172 154.988 312.443 153.973 313.21 152.905L316.009 148.493C316.315 148.027 317.271 147.859 317.796 148.164L323.353 151.381C323.877 151.686 324.135 152.268 323.964 152.841L320.858 157.737C320.368 158.428 319.461 158.657 318.937 158.352Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M315.503 146.517L310.262 143.46C309.738 143.153 309.009 142.139 309.776 141.07L312.575 136.658C312.882 136.193 313.837 136.024 314.362 136.33L319.918 139.547C320.442 139.853 320.701 140.434 320.531 141.007L317.425 145.902C316.934 146.594 316.028 146.823 315.503 146.517Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M307.371 141.8L302.129 138.743C301.605 138.437 300.876 137.422 301.643 136.354L304.442 131.941C304.749 131.476 305.705 131.307 306.229 131.613L311.786 134.829C312.31 135.135 312.569 135.717 312.398 136.29L309.292 141.186C308.801 141.876 307.895 142.106 307.371 141.8Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M310.844 153.582L305.602 150.524C305.078 150.219 304.349 149.204 305.116 148.135L307.915 143.723C308.222 143.258 309.177 143.089 309.702 143.395L315.259 146.611C315.783 146.917 316.041 147.499 315.871 148.072L312.764 152.968C312.275 153.658 311.368 153.888 310.844 153.582Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M302.68 148.892L297.439 145.834C296.915 145.529 296.186 144.514 296.953 143.446L299.752 139.033C300.059 138.568 301.014 138.399 301.538 138.705L307.096 141.921C307.62 142.227 307.878 142.809 307.708 143.382L304.601 148.278C304.111 148.969 303.205 149.198 302.68 148.892Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M322.414 170.172L317.171 167.114C316.647 166.808 315.918 165.794 316.686 164.725L319.484 160.313C319.791 159.848 320.747 159.679 321.271 159.985L326.828 163.201C327.352 163.507 327.61 164.088 327.439 164.662L324.334 169.557C323.844 170.248 322.938 170.478 322.414 170.172Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M314.251 165.483L309.01 162.425C308.486 162.119 307.757 161.104 308.524 160.036L311.323 155.624C311.629 155.159 312.585 154.99 313.11 155.295L318.667 158.512C319.191 158.817 319.449 159.399 319.278 159.973L316.173 164.868C315.682 165.559 314.776 165.788 314.251 165.483Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M306.163 160.713L300.921 157.656C300.397 157.349 299.668 156.335 300.436 155.266L303.235 150.854C303.541 150.389 304.497 150.22 305.021 150.526L310.578 153.743C311.102 154.048 311.361 154.63 311.19 155.203L308.085 160.098C307.594 160.789 306.688 161.019 306.163 160.713Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M298 156.024L292.758 152.966C292.234 152.66 291.505 151.646 292.272 150.577L295.071 146.165C295.378 145.7 296.333 145.531 296.857 145.837L302.415 149.053C302.939 149.359 303.197 149.94 303.027 150.514L299.921 155.409C299.431 156.1 298.525 156.33 298 156.024Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M325.761 103.58L294.544 153.903L325.761 103.58Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M325.761 103.58L294.544 153.903L325.761 103.58Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M327.795 104.835L296.579 155.158L327.795 104.835Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M327.795 104.835L296.579 155.158L327.795 104.835Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M333.782 108.373L302.566 158.696L333.782 108.373Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M333.782 108.373L302.566 158.696L333.782 108.373Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M335.812 109.629L304.596 159.952L335.812 109.629Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M335.812 109.629L304.596 159.952L335.812 109.629Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M341.805 113.054L310.588 163.377L341.805 113.054Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M341.805 113.054L310.588 163.377L341.805 113.054Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M343.841 114.309L312.623 164.632L343.841 114.309Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M343.841 114.309L312.623 164.632L343.841 114.309Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M349.824 117.734L318.608 168.057L349.824 117.734Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M349.824 117.734L318.608 168.057L349.824 117.734Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M351.856 118.99L320.639 169.313L351.856 118.99Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M351.856 118.99L320.639 169.313L351.856 118.99Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M323.188 101.714L323.017 101.805L355.644 120.874L355.801 120.782L323.188 101.714Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M323.016 101.805L322.961 101.992L355.432 120.908L355.461 120.785L323.016 101.805Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M355.642 120.873L355.799 120.783L324.144 171.299L323.8 171.507L355.642 120.873Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M355.639 120.873L355.488 120.784L323.659 171.424L323.798 171.507L355.639 120.873Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M323.19 102.12L323.324 102.2L291.338 152.298L291.135 152.376L323.19 102.12Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M323.244 101.934L323.019 101.802L290.882 152.23L291.133 152.376L323.244 101.934Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M291.403 152.088L291.203 152.144L323.709 171.266L323.75 171.136L291.403 152.088Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M291.207 152.144L291.135 152.376L323.664 171.426L323.712 171.267L291.207 152.144Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M357.403 120.349L358.578 121.966L326.503 175.277L325.318 173.671L357.403 120.349Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M325.324 173.661L326.5 175.277L291.241 154.712L289.625 152.986L325.324 173.661Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M287.311 207.561L271.499 209.256L237.199 189.678L279.767 162.708L322.418 187.235L287.311 207.561Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M262.572 195.745C262.572 198.044 259.209 199.908 255.062 199.908C250.914 199.908 247.551 198.044 247.551 195.745C247.551 193.446 250.914 191.583 255.062 191.583C259.209 191.583 262.572 193.446 262.572 195.745Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M262.566 195.612C262.568 195.656 262.572 195.702 262.572 195.746C262.572 198.045 259.209 199.908 255.061 199.908C250.913 199.908 247.551 198.045 247.551 195.746V197.792H247.557C247.67 200.036 250.984 201.837 255.061 201.837C259.209 201.837 262.572 199.973 262.572 197.674V195.612H262.566Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M266.768 130.867L301.399 150.985L269.313 204.304L233.624 183.618L266.768 130.867Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M267.243 132.51L299.641 151.507L267.8 201.848L235.393 182.724L267.243 132.51Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M293.914 157.981L288.672 154.923C288.148 154.617 287.419 153.603 288.186 152.534L290.985 148.122C291.292 147.657 292.247 147.488 292.771 147.793L298.328 151.01C298.852 151.316 299.111 151.897 298.941 152.471L295.835 157.366C295.345 158.057 294.438 158.286 293.914 157.981Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M285.783 153.264L280.542 150.206C280.018 149.9 279.289 148.885 280.056 147.816L282.855 143.405C283.162 142.94 284.117 142.771 284.641 143.076L290.198 146.293C290.722 146.598 290.981 147.18 290.811 147.754L287.705 152.649C287.214 153.34 286.308 153.569 285.783 153.264Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M289.25 165.045L284.008 161.987C283.484 161.681 282.755 160.667 283.522 159.598L286.322 155.186C286.628 154.721 287.584 154.552 288.108 154.857L293.665 158.074C294.189 158.38 294.448 158.961 294.277 159.535L291.171 164.43C290.681 165.121 289.775 165.35 289.25 165.045Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M281.093 160.356L275.851 157.299C275.326 156.992 274.598 155.978 275.365 154.909L278.165 150.497C278.471 150.032 279.427 149.863 279.951 150.168L285.508 153.385C286.033 153.691 286.29 154.272 286.119 154.846L283.014 159.741C282.524 160.432 281.617 160.661 281.093 160.356Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M277.661 148.522L272.42 145.464C271.896 145.158 271.167 144.144 271.934 143.075L274.733 138.663C275.039 138.198 275.995 138.029 276.519 138.335L282.076 141.551C282.6 141.857 282.859 142.439 282.688 143.012L279.583 147.908C279.092 148.598 278.186 148.828 277.661 148.522Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M269.532 143.805L264.29 140.748C263.766 140.442 263.037 139.427 263.804 138.359L266.604 133.946C266.91 133.481 267.866 133.312 268.39 133.618L273.947 136.835C274.471 137.14 274.73 137.723 274.559 138.295L271.453 143.191C270.963 143.882 270.057 144.111 269.532 143.805Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M272.999 155.586L267.758 152.528C267.233 152.222 266.505 151.208 267.272 150.139L270.071 145.727C270.377 145.262 271.333 145.093 271.857 145.399L277.414 148.615C277.938 148.921 278.197 149.502 278.026 150.076L274.92 154.971C274.43 155.662 273.523 155.892 272.999 155.586Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M264.842 150.897L259.6 147.839C259.076 147.533 258.347 146.519 259.114 145.45L261.914 141.038C262.22 140.573 263.176 140.404 263.7 140.71L269.258 143.926C269.782 144.232 270.04 144.813 269.869 145.387L266.763 150.282C266.273 150.973 265.367 151.203 264.842 150.897Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M284.717 172.216L279.475 169.158C278.951 168.852 278.222 167.838 278.989 166.77L281.788 162.357C282.095 161.892 283.05 161.723 283.574 162.029L289.132 165.245C289.656 165.551 289.914 166.133 289.744 166.706L286.638 171.602C286.148 172.292 285.241 172.522 284.717 172.216Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M276.585 167.499L271.344 164.441C270.82 164.135 270.091 163.121 270.858 162.052L273.657 157.64C273.964 157.175 274.919 157.006 275.443 157.312L281.001 160.528C281.525 160.834 281.783 161.416 281.613 161.989L278.506 166.884C278.016 167.575 277.11 167.805 276.585 167.499Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M280.181 179.433L274.94 176.375C274.416 176.069 273.687 175.055 274.454 173.986L277.253 169.574C277.56 169.109 278.515 168.94 279.039 169.246L284.596 172.462C285.12 172.768 285.379 173.349 285.209 173.923L282.103 178.818C281.612 179.509 280.706 179.739 280.181 179.433Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M271.997 174.778L266.755 171.72C266.231 171.415 265.502 170.4 266.269 169.331L269.068 164.919C269.375 164.454 270.33 164.285 270.854 164.591L276.411 167.807C276.935 168.113 277.194 168.695 277.024 169.268L273.918 174.164C273.428 174.854 272.521 175.084 271.997 174.778Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M268.466 162.757L263.224 159.699C262.7 159.394 261.971 158.379 262.738 157.31L265.537 152.898C265.844 152.433 266.799 152.264 267.323 152.57L272.881 155.786C273.405 156.092 273.663 156.674 273.493 157.247L270.387 162.143C269.897 162.833 268.991 163.063 268.466 162.757Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M260.334 158.04L255.092 154.983C254.567 154.676 253.838 153.662 254.606 152.593L257.405 148.181C257.712 147.716 258.667 147.547 259.191 147.852L264.749 151.07C265.273 151.375 265.531 151.957 265.36 152.53L262.254 157.425C261.765 158.117 260.858 158.345 260.334 158.04Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M263.804 169.949L258.562 166.892C258.037 166.585 257.309 165.571 258.076 164.502L260.875 160.09C261.182 159.625 262.137 159.456 262.661 159.761L268.218 162.978C268.743 163.284 269.001 163.865 268.83 164.439L265.724 169.334C265.235 170.025 264.328 170.254 263.804 169.949Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M255.639 165.268L250.397 162.211C249.873 161.905 249.144 160.89 249.911 159.822L252.71 155.409C253.017 154.944 253.972 154.775 254.497 155.082L260.054 158.298C260.579 158.604 260.836 159.186 260.666 159.758L257.56 164.654C257.07 165.345 256.164 165.574 255.639 165.268Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M275.754 186.609L270.512 183.552C269.987 183.246 269.259 182.231 270.026 181.162L272.825 176.75C273.132 176.285 274.087 176.116 274.611 176.422L280.168 179.638C280.692 179.944 280.951 180.526 280.78 181.099L277.674 185.995C277.185 186.686 276.278 186.915 275.754 186.609Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M267.629 181.893L262.387 178.836C261.863 178.529 261.134 177.515 261.902 176.446L264.701 172.034C265.007 171.569 265.963 171.4 266.487 171.705L272.044 174.923C272.568 175.228 272.827 175.81 272.655 176.383L269.55 181.278C269.06 181.969 268.153 182.198 267.629 181.893Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M271.093 193.673L265.851 190.616C265.327 190.31 264.598 189.295 265.365 188.226L268.164 183.814C268.471 183.349 269.426 183.18 269.95 183.486L275.507 186.703C276.031 187.008 276.29 187.59 276.12 188.163L273.014 193.059C272.524 193.75 271.617 193.979 271.093 193.673Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M262.929 188.984L257.687 185.926C257.163 185.621 256.434 184.606 257.201 183.538L260.001 179.125C260.307 178.66 261.263 178.491 261.787 178.797L267.345 182.013C267.869 182.319 268.127 182.901 267.956 183.474L264.85 188.37C264.36 189.06 263.453 189.29 262.929 188.984Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M259.508 177.15L254.266 174.093C253.742 173.787 253.013 172.772 253.78 171.704L256.579 167.291C256.886 166.826 257.841 166.657 258.365 166.963L263.923 170.18C264.447 170.485 264.705 171.068 264.535 171.64L261.429 176.536C260.939 177.227 260.033 177.456 259.508 177.15Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M251.377 172.434L246.136 169.376C245.612 169.07 244.883 168.056 245.65 166.987L248.449 162.575C248.755 162.11 249.711 161.941 250.235 162.246L255.792 165.463C256.316 165.769 256.575 166.35 256.404 166.924L253.299 171.819C252.808 172.51 251.902 172.739 251.377 172.434Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M254.846 184.215L249.604 181.158C249.08 180.852 248.351 179.837 249.118 178.769L251.917 174.356C252.224 173.891 253.179 173.722 253.703 174.029L259.261 177.245C259.785 177.551 260.043 178.132 259.873 178.705L256.767 183.601C256.277 184.292 255.37 184.521 254.846 184.215Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M246.677 179.526L241.435 176.468C240.911 176.162 240.182 175.148 240.949 174.079L243.748 169.667C244.055 169.202 245.01 169.033 245.534 169.339L251.092 172.555C251.616 172.861 251.874 173.442 251.704 174.016L248.598 178.911C248.108 179.602 247.202 179.832 246.677 179.526Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M266.412 200.805L261.17 197.748C260.646 197.441 259.917 196.427 260.684 195.358L263.483 190.946C263.79 190.481 264.745 190.312 265.27 190.618L270.827 193.835C271.351 194.14 271.609 194.722 271.438 195.295L268.333 200.19C267.843 200.882 266.936 201.111 266.412 200.805Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M258.248 196.115L253.006 193.058C252.482 192.752 251.753 191.737 252.52 190.668L255.32 186.256C255.626 185.791 256.582 185.622 257.106 185.928L262.664 189.145C263.188 189.45 263.446 190.032 263.275 190.605L260.17 195.501C259.679 196.192 258.773 196.421 258.248 196.115Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M250.159 191.346L244.918 188.289C244.394 187.982 243.665 186.968 244.432 185.899L247.231 181.487C247.538 181.022 248.493 180.853 249.017 181.159L254.574 184.375C255.098 184.681 255.357 185.262 255.187 185.836L252.081 190.731C251.59 191.422 250.684 191.652 250.159 191.346Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M242.001 186.657L236.76 183.599C236.236 183.293 235.507 182.278 236.274 181.209L239.073 176.798C239.379 176.333 240.335 176.164 240.859 176.469L246.417 179.686C246.941 179.991 247.199 180.573 247.028 181.147L243.923 186.042C243.432 186.733 242.525 186.962 242.001 186.657Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M269.757 134.213L238.541 184.536L269.757 134.213Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M269.757 134.213L238.541 184.536L269.757 134.213Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M271.792 135.468L240.575 185.791L271.792 135.468Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M271.792 135.468L240.575 185.791L271.792 135.468Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M277.784 139.006L246.567 189.329L277.784 139.006Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M277.784 139.006L246.567 189.329L277.784 139.006Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M279.817 140.262L248.6 190.585L279.817 140.262Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M279.817 140.262L248.6 190.585L279.817 140.262Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M285.806 143.687L254.59 194.01L285.806 143.687Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M285.806 143.687L254.59 194.01L285.806 143.687Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M287.836 144.942L256.62 195.265L287.836 144.942Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M287.836 144.942L256.62 195.265L287.836 144.942Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M293.822 148.367L262.605 198.69L293.822 148.367Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M293.822 148.367L262.605 198.69L293.822 148.367Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M295.861 149.623L264.645 199.946L295.861 149.623Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M295.861 149.623L264.645 199.946L295.861 149.623Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M267.19 132.347L267.019 132.438L299.646 151.507L299.801 151.415L267.19 132.347Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M267.017 132.437L266.963 132.624L299.434 151.542L299.462 151.418L267.017 132.437Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M299.64 151.506L299.796 151.416L268.142 201.932L267.798 202.139L299.64 151.506Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M299.642 151.506L299.491 151.418L267.662 202.058L267.801 202.14L299.642 151.506Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M267.187 132.754L267.321 132.833L235.336 182.932L235.133 183.009L267.187 132.754Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M267.24 132.566L267.015 132.435L234.878 182.862L235.129 183.009L267.24 132.566Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M235.405 182.722L235.206 182.777L267.711 201.9L267.752 201.77L235.405 182.722Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M235.204 182.777L235.133 183.009L267.66 202.059L267.71 201.9L235.204 182.777Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M301.401 150.981L302.577 152.598L270.5 205.91L269.315 204.304L301.401 150.981Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M269.322 204.293L270.498 205.91L235.238 185.345L233.624 183.618L269.322 204.293Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M354.498 186.04C354.498 188.339 351.136 190.203 346.988 190.203C342.84 190.203 339.478 188.339 339.478 186.04C339.478 183.741 342.84 181.877 346.988 181.877C351.136 181.877 354.498 183.741 354.498 186.04Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M354.492 185.906C354.494 185.95 354.498 185.995 354.498 186.039C354.498 188.338 351.136 190.202 346.988 190.202C342.84 190.202 339.478 188.338 339.478 186.039V188.086H339.484C339.596 190.33 342.911 192.13 346.988 192.13C351.136 192.13 354.498 190.266 354.498 187.967V185.906H354.492Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M358.692 121.162L393.323 141.279L361.236 194.598L325.548 173.913L358.692 121.162Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M359.163 122.804L391.561 141.801L359.72 192.142L327.313 173.018L359.163 122.804Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M385.836 148.276L380.595 145.218C380.071 144.912 379.342 143.898 380.109 142.829L382.908 138.417C383.214 137.952 384.17 137.783 384.695 138.088L390.251 141.305C390.775 141.611 391.034 142.192 390.863 142.766L387.758 147.661C387.267 148.352 386.361 148.581 385.836 148.276Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M377.707 143.558L372.465 140.5C371.94 140.194 371.211 139.18 371.979 138.111L374.778 133.699C375.085 133.234 376.04 133.065 376.564 133.37L382.122 136.587C382.646 136.893 382.904 137.474 382.734 138.048L379.627 142.943C379.138 143.634 378.231 143.863 377.707 143.558Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M381.175 155.339L375.933 152.282C375.409 151.976 374.68 150.961 375.447 149.893L378.247 145.48C378.553 145.015 379.509 144.846 380.033 145.152L385.59 148.368C386.114 148.674 386.373 149.256 386.202 149.829L383.097 154.725C382.606 155.416 381.7 155.645 381.175 155.339Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M373.017 150.65L367.775 147.593C367.251 147.286 366.522 146.272 367.289 145.203L370.089 140.791C370.395 140.326 371.351 140.157 371.875 140.463L377.433 143.68C377.957 143.985 378.215 144.567 378.044 145.14L374.938 150.035C374.448 150.727 373.541 150.956 373.017 150.65Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M369.59 138.816L364.349 135.759C363.825 135.453 363.096 134.438 363.863 133.37L366.662 128.957C366.968 128.492 367.924 128.323 368.449 128.629L374.005 131.846C374.529 132.151 374.788 132.733 374.617 133.306L371.512 138.202C371.021 138.893 370.114 139.122 369.59 138.816Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M361.458 134.1L356.215 131.042C355.691 130.736 354.962 129.721 355.73 128.652L358.529 124.241C358.836 123.776 359.791 123.607 360.315 123.912L365.873 127.129C366.397 127.434 366.655 128.016 366.485 128.59L363.378 133.485C362.888 134.176 361.982 134.405 361.458 134.1Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M364.928 145.88L359.687 142.823C359.162 142.517 358.434 141.502 359.201 140.434L362 136.021C362.306 135.556 363.262 135.387 363.787 135.693L369.343 138.909C369.867 139.215 370.126 139.797 369.955 140.37L366.849 145.266C366.359 145.957 365.453 146.186 364.928 145.88Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M356.765 141.191L351.523 138.134C350.998 137.827 350.27 136.813 351.037 135.744L353.836 131.332C354.143 130.867 355.098 130.698 355.623 131.004L361.18 134.22C361.705 134.526 361.962 135.107 361.792 135.681L358.686 140.576C358.195 141.267 357.289 141.497 356.765 141.191Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M376.641 162.511L371.399 159.453C370.875 159.147 370.146 158.133 370.914 157.064L373.712 152.652C374.018 152.187 374.975 152.018 375.499 152.323L381.055 155.54C381.58 155.846 381.837 156.427 381.667 157.001L378.562 161.896C378.071 162.587 377.165 162.816 376.641 162.511Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M368.508 157.793L363.266 154.736C362.742 154.43 362.013 153.415 362.781 152.347L365.58 147.934C365.886 147.469 366.842 147.3 367.366 147.606L372.924 150.822C373.448 151.128 373.706 151.71 373.535 152.283L370.429 157.179C369.939 157.87 369.032 158.099 368.508 157.793Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M372.103 169.727L366.861 166.67C366.337 166.364 365.608 165.349 366.375 164.281L369.174 159.868C369.481 159.403 370.436 159.234 370.961 159.54L376.518 162.757C377.042 163.062 377.3 163.644 377.13 164.217L374.024 169.113C373.534 169.804 372.628 170.033 372.103 169.727Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M363.92 165.073L358.679 162.015C358.154 161.709 357.426 160.694 358.193 159.626L360.992 155.214C361.298 154.749 362.254 154.58 362.779 154.885L368.335 158.102C368.859 158.407 369.118 158.989 368.947 159.562L365.842 164.458C365.351 165.149 364.445 165.378 363.92 165.073Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M360.392 153.051L355.151 149.993C354.627 149.687 353.898 148.673 354.665 147.604L357.464 143.192C357.77 142.727 358.726 142.558 359.251 142.864L364.807 146.08C365.331 146.386 365.59 146.967 365.419 147.541L362.314 152.436C361.823 153.127 360.917 153.357 360.392 153.051Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M352.263 148.334L347.021 145.277C346.497 144.971 345.768 143.956 346.535 142.887L349.335 138.475C349.641 138.01 350.597 137.841 351.121 138.147L356.678 141.364C357.203 141.669 357.461 142.251 357.29 142.824L354.184 147.72C353.694 148.411 352.787 148.64 352.263 148.334Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M355.727 160.244L350.484 157.186C349.96 156.88 349.231 155.865 349.999 154.797L352.797 150.385C353.104 149.919 354.06 149.751 354.584 150.057L360.141 153.273C360.665 153.579 360.923 154.161 360.752 154.733L357.647 159.629C357.157 160.321 356.251 160.549 355.727 160.244Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M347.564 155.562L342.323 152.505C341.799 152.199 341.07 151.184 341.837 150.115L344.636 145.703C344.942 145.238 345.898 145.069 346.423 145.375L351.98 148.592C352.504 148.897 352.762 149.479 352.591 150.052L349.486 154.948C348.995 155.639 348.088 155.868 347.564 155.562Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M367.679 176.905L362.437 173.847C361.912 173.541 361.184 172.527 361.951 171.458L364.75 167.046C365.057 166.581 366.012 166.412 366.537 166.718L372.094 169.934C372.618 170.24 372.876 170.821 372.706 171.395L369.6 176.29C369.11 176.981 368.203 177.211 367.679 176.905Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M359.552 172.187L354.309 169.13C353.785 168.823 353.056 167.809 353.824 166.74L356.623 162.328C356.929 161.863 357.885 161.694 358.409 162L363.966 165.217C364.49 165.522 364.748 166.104 364.577 166.677L361.472 171.572C360.982 172.264 360.076 172.493 359.552 172.187Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M363.017 183.968L357.775 180.91C357.25 180.605 356.521 179.59 357.289 178.522L360.088 174.109C360.395 173.644 361.35 173.475 361.875 173.781L367.432 176.997C367.956 177.303 368.214 177.885 368.044 178.458L364.938 183.354C364.447 184.044 363.541 184.274 363.017 183.968Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M354.86 179.279L349.618 176.221C349.093 175.915 348.365 174.9 349.132 173.832L351.931 169.42C352.237 168.954 353.193 168.786 353.718 169.091L359.274 172.308C359.799 172.613 360.057 173.195 359.887 173.768L356.781 178.664C356.29 179.355 355.384 179.584 354.86 179.279Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M351.432 167.445L346.19 164.388C345.666 164.081 344.937 163.066 345.705 161.998L348.503 157.586C348.81 157.121 349.766 156.952 350.29 157.258L355.848 160.474C356.372 160.78 356.63 161.362 356.459 161.935L353.353 166.83C352.862 167.522 351.956 167.75 351.432 167.445Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M343.301 162.728L338.059 159.671C337.535 159.365 336.806 158.35 337.573 157.282L340.373 152.869C340.679 152.404 341.635 152.235 342.159 152.541L347.716 155.757C348.24 156.063 348.499 156.645 348.328 157.218L345.222 162.114C344.732 162.804 343.826 163.034 343.301 162.728Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M346.765 174.509L341.522 171.451C340.998 171.146 340.269 170.131 341.037 169.062L343.835 164.65C344.142 164.185 345.098 164.016 345.622 164.322L351.179 167.538C351.704 167.844 351.962 168.426 351.792 168.999L348.685 173.895C348.195 174.585 347.289 174.815 346.765 174.509Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M338.607 169.82L333.365 166.762C332.841 166.456 332.112 165.442 332.88 164.373L335.678 159.961C335.985 159.496 336.94 159.327 337.465 159.633L343.022 162.849C343.546 163.155 343.804 163.736 343.634 164.31L340.528 169.205C340.038 169.896 339.132 170.126 338.607 169.82Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M358.334 191.1L353.093 188.042C352.568 187.736 351.84 186.722 352.607 185.652L355.406 181.241C355.712 180.776 356.668 180.607 357.192 180.912L362.749 184.129C363.273 184.435 363.532 185.016 363.361 185.59L360.255 190.485C359.765 191.176 358.859 191.405 358.334 191.1Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M350.178 186.41L344.935 183.352C344.411 183.046 343.682 182.031 344.45 180.963L347.249 176.551C347.556 176.086 348.511 175.917 349.035 176.222L354.593 179.439C355.117 179.744 355.375 180.326 355.205 180.9L352.098 185.795C351.608 186.486 350.702 186.715 350.178 186.41Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M342.089 181.64L336.847 178.583C336.323 178.277 335.594 177.262 336.362 176.194L339.16 171.781C339.467 171.316 340.423 171.147 340.947 171.453L346.505 174.67C347.029 174.975 347.287 175.557 347.116 176.13L344.01 181.026C343.519 181.716 342.613 181.946 342.089 181.64Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M333.925 176.952L328.683 173.894C328.159 173.588 327.43 172.574 328.198 171.505L330.996 167.093C331.303 166.628 332.259 166.459 332.783 166.765L338.339 169.981C338.864 170.287 339.121 170.868 338.951 171.442L335.846 176.337C335.356 177.028 334.449 177.258 333.925 176.952Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M361.681 124.508L330.464 174.831L361.681 124.508Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M361.681 124.508L330.464 174.831L361.681 124.508Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M363.717 125.762L332.499 176.085L363.717 125.762Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M363.717 125.762L332.499 176.085L363.717 125.762Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M369.708 129.301L338.491 179.624L369.708 129.301Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M369.708 129.301L338.491 179.624L369.708 129.301Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M371.738 130.556L340.521 180.879L371.738 130.556Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M371.738 130.556L340.521 180.879L371.738 130.556Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M377.725 133.981L346.508 184.304L377.725 133.981Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M377.725 133.981L346.508 184.304L377.725 133.981Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M379.759 135.237L348.542 185.56L379.759 135.237Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M379.759 135.237L348.542 185.56L379.759 135.237Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M385.752 138.662L354.536 188.985L385.752 138.662Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M385.752 138.662L354.536 188.985L385.752 138.662Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M387.782 139.917L356.566 190.24L387.782 139.917Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M387.782 139.917L356.566 190.24L387.782 139.917Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M359.109 122.642L358.938 122.733L391.565 141.802L391.721 141.71L359.109 122.642Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M358.942 122.733L358.886 122.92L391.358 141.836L391.385 141.713L358.942 122.733Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M391.564 141.8L391.72 141.711L360.066 192.226L359.721 192.434L391.564 141.8Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M391.565 141.8L391.414 141.711L359.584 192.351L359.723 192.434L391.565 141.8Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M359.112 123.048L359.246 123.127L327.26 173.226L327.058 173.303L359.112 123.048Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M359.17 122.86L358.944 122.728L326.808 173.156L327.058 173.302L359.17 122.86Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M327.329 173.016L327.129 173.072L359.636 192.195L359.676 192.064L327.329 173.016Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M327.129 173.071L327.058 173.303L359.586 192.353L359.635 192.194L327.129 173.071Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M393.323 141.275L394.499 142.892L362.422 196.203L361.237 194.598L393.323 141.275Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M361.246 194.587L362.421 196.203L327.162 175.638L325.548 173.912L361.246 194.587Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M323.232 228.489L307.421 230.184L273.12 210.606L315.688 183.636L358.339 208.162L323.232 228.489Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M298.493 216.673C298.493 218.972 295.13 220.836 290.983 220.836C286.835 220.836 283.472 218.972 283.472 216.673C283.472 214.374 286.835 212.51 290.983 212.51C295.13 212.51 298.493 214.374 298.493 216.673Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M298.493 216.539C298.496 216.584 298.499 216.629 298.499 216.673C298.499 218.972 295.137 220.836 290.989 220.836C286.841 220.836 283.479 218.972 283.479 216.673V218.72H283.485C283.598 220.964 286.912 222.764 290.989 222.764C295.137 222.764 298.499 220.9 298.499 218.601V216.539H298.493Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M302.693 151.795L337.325 171.913L305.238 225.231L269.549 204.545L302.693 151.795Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    d: "M303.168 153.438L335.567 172.435L303.725 222.776L271.318 203.652L303.168 153.438Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M329.839 178.908L324.597 175.85C324.073 175.545 323.344 174.53 324.111 173.462L326.91 169.049C327.217 168.584 328.172 168.415 328.697 168.721L334.254 171.937C334.778 172.243 335.036 172.825 334.866 173.398L331.76 178.294C331.27 178.985 330.363 179.214 329.839 178.908Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    d: "M321.708 174.191L316.466 171.133C315.942 170.828 315.213 169.813 315.98 168.744L318.779 164.332C319.086 163.867 320.042 163.698 320.566 164.004L326.123 167.22C326.648 167.526 326.906 168.108 326.735 168.681L323.629 173.577C323.138 174.267 322.232 174.497 321.708 174.191Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M325.176 185.973L319.934 182.915C319.41 182.609 318.681 181.595 319.448 180.526L322.248 176.114C322.554 175.649 323.51 175.48 324.034 175.786L329.591 179.002C330.115 179.308 330.373 179.889 330.203 180.463L327.097 185.358C326.607 186.049 325.7 186.279 325.176 185.973Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    d: "M317.014 181.283L311.771 178.226C311.247 177.919 310.518 176.905 311.286 175.836L314.085 171.424C314.392 170.959 315.347 170.79 315.871 171.096L321.429 174.312C321.953 174.618 322.211 175.2 322.041 175.773L318.934 180.668C318.444 181.359 317.538 181.589 317.014 181.283Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M313.588 169.449L308.346 166.391C307.821 166.085 307.093 165.071 307.86 164.002L310.659 159.59C310.966 159.125 311.921 158.956 312.445 159.262L318.002 162.478C318.526 162.784 318.785 163.365 318.615 163.939L315.508 168.834C315.019 169.525 314.112 169.755 313.588 169.449Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    d: "M305.456 164.732L300.214 161.675C299.69 161.369 298.96 160.354 299.727 159.286L302.527 154.873C302.834 154.408 303.79 154.239 304.314 154.545L309.87 157.762C310.394 158.067 310.652 158.65 310.482 159.222L307.377 164.118C306.886 164.809 305.98 165.038 305.456 164.732Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M308.925 176.513L303.684 173.455C303.159 173.15 302.431 172.135 303.198 171.067L305.996 166.654C306.304 166.189 307.259 166.02 307.783 166.326L313.34 169.542C313.864 169.848 314.123 170.43 313.953 171.003L310.846 175.899C310.356 176.59 309.45 176.819 308.925 176.513Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M300.765 171.825L295.523 168.767C294.999 168.461 294.27 167.447 295.037 166.378L297.836 161.966C298.143 161.501 299.098 161.332 299.623 161.637L305.18 164.854C305.705 165.16 305.962 165.741 305.791 166.315L302.686 171.21C302.196 171.901 301.29 172.13 300.765 171.825Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M320.64 193.143L315.398 190.085C314.874 189.779 314.145 188.765 314.912 187.696L317.711 183.284C318.018 182.819 318.973 182.65 319.498 182.956L325.054 186.172C325.579 186.478 325.837 187.059 325.667 187.633L322.561 192.528C322.071 193.219 321.165 193.449 320.64 193.143Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M312.512 188.426L307.27 185.369C306.745 185.063 306.016 184.048 306.784 182.979L309.582 178.567C309.89 178.102 310.845 177.933 311.369 178.239L316.927 181.455C317.451 181.761 317.709 182.343 317.539 182.916L314.432 187.812C313.942 188.503 313.036 188.732 312.512 188.426Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M316.102 200.361L310.86 197.303C310.335 196.997 309.607 195.983 310.374 194.915L313.173 190.502C313.48 190.037 314.435 189.868 314.959 190.174L320.516 193.39C321.04 193.696 321.299 194.278 321.129 194.851L318.022 199.746C317.532 200.437 316.626 200.667 316.102 200.361Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M307.919 195.705L302.677 192.647C302.153 192.341 301.424 191.327 302.191 190.258L304.991 185.846C305.297 185.381 306.253 185.212 306.777 185.518L312.334 188.734C312.858 189.04 313.117 189.621 312.946 190.195L309.84 195.09C309.35 195.781 308.443 196.011 307.919 195.705Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M304.388 183.684L299.147 180.626C298.623 180.32 297.894 179.306 298.661 178.237L301.46 173.825C301.767 173.36 302.722 173.191 303.246 173.497L308.803 176.713C309.327 177.019 309.586 177.6 309.416 178.174L306.31 183.069C305.819 183.76 304.913 183.99 304.388 183.684Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M296.254 178.967L291.013 175.91C290.488 175.603 289.759 174.589 290.527 173.521L293.326 169.108C293.632 168.643 294.588 168.474 295.112 168.78L300.67 171.997C301.194 172.303 301.452 172.884 301.281 173.457L298.175 178.352C297.685 179.044 296.779 179.273 296.254 178.967Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M299.727 190.876L294.485 187.819C293.96 187.512 293.232 186.498 293.999 185.43L296.798 181.017C297.105 180.552 298.06 180.383 298.584 180.689L304.142 183.905C304.666 184.211 304.924 184.793 304.753 185.366L301.647 190.261C301.158 190.952 300.251 191.182 299.727 190.876Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M291.563 186.195L286.321 183.138C285.797 182.832 285.068 181.817 285.835 180.749L288.634 176.336C288.941 175.871 289.896 175.702 290.42 176.009L295.978 179.225C296.502 179.531 296.76 180.112 296.59 180.685L293.484 185.581C292.994 186.272 292.088 186.501 291.563 186.195Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M311.682 207.537L306.439 204.48C305.915 204.174 305.186 203.159 305.954 202.09L308.752 197.678C309.06 197.213 310.015 197.044 310.539 197.35L316.097 200.566C316.621 200.872 316.879 201.454 316.709 202.027L313.602 206.923C313.112 207.614 312.206 207.843 311.682 207.537Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M303.55 202.821L298.308 199.763C297.784 199.457 297.055 198.442 297.822 197.374L300.621 192.962C300.928 192.496 301.883 192.328 302.408 192.633L307.964 195.85C308.488 196.155 308.747 196.738 308.577 197.31L305.471 202.206C304.981 202.897 304.074 203.126 303.55 202.821Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M307.019 214.602L301.778 211.544C301.253 211.238 300.524 210.223 301.292 209.154L304.09 204.743C304.397 204.278 305.353 204.109 305.877 204.414L311.434 207.631C311.959 207.936 312.217 208.518 312.046 209.092L308.94 213.987C308.45 214.678 307.543 214.907 307.019 214.602Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M298.857 209.911L293.615 206.854C293.091 206.548 292.362 205.533 293.129 204.465L295.928 200.052C296.235 199.587 297.19 199.418 297.714 199.724L303.272 202.941C303.796 203.246 304.054 203.828 303.883 204.401L300.778 209.297C300.288 209.988 299.381 210.217 298.857 209.911Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M295.429 198.078L290.187 195.021C289.663 194.714 288.934 193.7 289.701 192.632L292.5 188.219C292.807 187.754 293.762 187.585 294.286 187.891L299.844 191.108C300.368 191.413 300.626 191.995 300.456 192.568L297.35 197.463C296.86 198.154 295.954 198.384 295.429 198.078Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M287.296 193.361L282.055 190.303C281.53 189.998 280.802 188.983 281.569 187.915L284.368 183.502C284.674 183.037 285.63 182.868 286.154 183.174L291.711 186.39C292.235 186.696 292.494 187.278 292.323 187.851L289.218 192.747C288.727 193.438 287.821 193.667 287.296 193.361Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M290.767 205.142L285.525 202.085C285.001 201.779 284.272 200.764 285.039 199.696L287.838 195.283C288.145 194.818 289.1 194.649 289.624 194.956L295.181 198.172C295.705 198.478 295.964 199.06 295.794 199.632L292.688 204.528C292.198 205.219 291.291 205.448 290.767 205.142Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    d: "M282.603 200.453L277.361 197.396C276.837 197.09 276.108 196.075 276.875 195.006L279.675 190.594C279.981 190.129 280.937 189.96 281.461 190.266L287.019 193.482C287.543 193.788 287.801 194.37 287.63 194.943L284.524 199.839C284.034 200.53 283.128 200.759 282.603 200.453Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M302.337 221.732L297.095 218.675C296.571 218.369 295.842 217.354 296.609 216.286L299.408 211.873C299.715 211.408 300.67 211.239 301.194 211.546L306.751 214.762C307.276 215.068 307.534 215.65 307.364 216.222L304.257 221.118C303.768 221.809 302.861 222.038 302.337 221.732Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    d: "M294.176 217.044L288.934 213.986C288.41 213.68 287.681 212.666 288.448 211.596L291.248 207.185C291.554 206.72 292.51 206.551 293.034 206.856L298.592 210.073C299.116 210.379 299.374 210.96 299.203 211.534L296.097 216.429C295.607 217.12 294.701 217.349 294.176 217.044Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M286.086 212.273L280.844 209.216C280.32 208.909 279.591 207.895 280.358 206.827L283.157 202.414C283.464 201.949 284.419 201.78 284.943 202.086L290.5 205.302C291.025 205.608 291.283 206.19 291.113 206.763L288.007 211.658C287.517 212.349 286.611 212.579 286.086 212.273Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    d: "M277.924 207.584L272.682 204.526C272.158 204.221 271.429 203.206 272.196 202.137L274.995 197.725C275.302 197.26 276.257 197.091 276.781 197.397L282.339 200.613C282.863 200.919 283.121 201.501 282.951 202.074L279.845 206.97C279.355 207.66 278.448 207.89 277.924 207.584Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M305.682 155.14L274.466 205.463L305.682 155.14Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    d: "M305.682 155.14L274.466 205.463L305.682 155.14Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    d: "M307.715 156.396L276.499 206.718L307.715 156.396Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M307.715 156.396L276.499 206.718L307.715 156.396Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    d: "M313.706 159.934L282.49 210.257L313.706 159.934Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M313.706 159.934L282.49 210.257L313.706 159.934Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M315.739 161.189L284.522 211.512L315.739 161.189Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M315.739 161.189L284.522 211.512L315.739 161.189Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    d: "M321.729 164.614L290.512 214.937L321.729 164.614Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M321.729 164.614L290.512 214.937L321.729 164.614Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    d: "M323.76 165.869L292.543 216.192L323.76 165.869Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    d: "M323.76 165.869L292.543 216.192L323.76 165.869Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    d: "M329.744 169.295L298.528 219.618L329.744 169.295Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M329.744 169.295L298.528 219.618L329.744 169.295Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M331.787 170.55L300.57 220.873L331.787 170.55Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M331.787 170.55L300.57 220.873L331.787 170.55Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M303.11 153.275L302.94 153.366L335.566 172.435L335.722 172.343L303.11 153.275Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    d: "M302.938 153.365L302.883 153.552L335.355 172.47L335.383 172.345L302.938 153.365Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    d: "M335.566 172.434L335.722 172.343L304.068 222.86L303.724 223.067L335.566 172.434Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M335.567 172.434L335.416 172.346L303.586 222.986L303.725 223.068L335.567 172.434Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    d: "M303.108 153.681L303.242 153.76L271.257 203.859L271.054 203.936L303.108 153.681Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M303.167 153.494L302.942 153.362L270.805 203.79L271.055 203.937L303.167 153.494Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M271.325 203.649L271.126 203.705L303.632 222.828L303.672 222.697L271.325 203.649Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    d: "M271.125 203.705L271.054 203.936L303.583 222.986L303.631 222.828L271.125 203.705Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    d: "M337.323 171.909L338.498 173.525L306.423 226.837L305.238 225.231L337.323 171.909Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    d: "M305.247 225.221L306.422 226.838L271.163 206.272L269.549 204.546L305.247 225.221Z",
    fill: "#F8F8F9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fragezeichen_Einspeiseanfrage"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.475 194.308L250.865 190.711L250.865 190.845C250.822 190.787 250.779 190.728 250.735 190.67L246.164 196.369C247.829 198.165 249.32 200.098 250.605 202.127C251.996 204.314 253.179 206.581 254.133 208.891C255.11 211.207 255.788 213.561 256.149 215.885C256.476 217.974 256.458 220.007 256.095 221.903C255.78 223.599 255.047 225.091 253.949 226.267C253.309 226.983 252.466 227.493 251.483 227.761C250.596 227.978 249.622 228 248.617 227.824C247.59 227.637 246.557 227.351 245.531 226.97L242.55 225.843C241.242 225.302 239.908 225.015 238.632 224.999C237.438 225.043 236.347 225.364 235.436 225.939C234.061 226.85 232.816 227.918 231.72 229.129L234.685 236.278L227.231 232.966L227.311 233.423L227.105 232.922L221.603 238.635L225.887 249.042L229.636 245.149L227.657 253.173L244.294 250.84L237.064 238.616L244.104 241.556L244.092 241.52L244.106 241.554C245.722 239.863 247.082 238.923 248.186 238.734C249.29 238.546 251.18 238.978 253.857 240.03C255.892 240.797 257.945 241.371 259.984 241.745C261.48 242.023 262.926 241.968 264.215 241.584C265.482 241.122 266.578 240.393 267.444 239.435C269.295 237.404 270.524 234.84 271.039 231.934C271.7 228.565 271.755 224.953 271.204 221.238C270.661 217.319 269.559 213.342 267.929 209.424C266.814 206.707 265.521 204.021 264.058 201.385C262.71 198.964 261.185 196.606 259.498 194.334L259.504 194.32L259.481 194.311L259.477 194.306L259.475 194.308Z",
    fill: "#2B2B2B",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    d: "M209.064 140.065C212.869 140.904 216.597 142.06 220.209 143.521C224.122 145.111 227.916 146.978 231.564 149.107C236.847 152.148 241.67 155.925 245.89 160.324C249.928 164.448 253.274 169.196 255.8 174.385C258.033 178.792 259.245 183.644 259.347 188.583C259.402 190.905 259.018 193.216 258.214 195.394C257.315 197.5 255.952 199.375 254.228 200.88C251.882 202.939 249.333 204.756 246.621 206.301C243.013 208.276 240.758 210.074 239.856 211.695C238.954 213.316 238.509 216.23 238.521 220.435L226.682 213.597C226.614 210.661 226.825 207.725 227.313 204.829C227.661 202.95 228.427 201.172 229.552 199.627C230.815 198.056 232.39 196.764 234.178 195.833L238.155 193.575C239.517 192.789 240.797 191.871 241.977 190.832C243.125 189.808 244.057 188.564 244.72 187.175C245.429 185.603 245.773 183.89 245.725 182.165C245.691 179.273 245.003 176.426 243.714 173.837C242.283 170.928 240.387 168.272 238.101 165.974C235.559 163.413 232.68 161.211 229.543 159.428C226.436 157.627 223.144 156.165 219.724 155.068C216.558 154.042 213.28 153.398 209.96 153.148L209.064 140.065ZM239.728 232.403V246.665L225.74 238.528V224.266L239.728 232.403Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 352",
    d: "M197.256 146.152L209.102 140.053L212.43 151.881L202.983 153.987L197.256 146.152Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 353",
    d: "M221.677 221.518L228.893 213.477L238.519 220.442L226.708 226.526L221.677 221.518Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 354",
    d: "M213.931 230.361L226.549 224.291L231.627 229.258L225.55 241.606L213.931 230.361Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 355",
    d: "M222.653 244.766L226.713 236.564L239.741 246.64L227.919 252.757L222.653 244.766Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 53",
    d: "M246.777 166.972C243.552 159.041 222.112 151.254 211.795 148.353L210.828 156.574L225.014 163.264L242.827 188.251L247.986 186.8C248.926 183.495 250.001 174.903 246.777 166.972Z",
    fill: "#B4005F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    d: "M197.09 146.261C200.895 147.101 204.622 148.257 208.234 149.717C212.147 151.307 215.942 153.174 219.589 155.303C224.872 158.344 229.696 162.121 233.915 166.521C237.953 170.645 241.299 175.392 243.825 180.582C246.058 184.988 247.271 189.841 247.373 194.78C247.428 197.101 247.043 199.412 246.239 201.591C245.34 203.696 243.978 205.571 242.253 207.076C239.907 209.136 237.359 210.952 234.647 212.498C231.038 214.472 228.783 216.27 227.881 217.892C226.979 219.513 226.534 222.426 226.546 226.632L214.707 219.793C214.639 216.857 214.851 213.922 215.338 211.026C215.687 209.146 216.452 207.369 217.578 205.824C218.841 204.252 220.416 202.961 222.204 202.03L226.181 199.771C227.542 198.986 228.822 198.067 230.002 197.029C231.15 196.004 232.082 194.761 232.745 193.372C233.455 191.799 233.798 190.086 233.751 188.362C233.716 185.47 233.029 182.622 231.739 180.033C230.309 177.124 228.413 174.468 226.126 172.171C223.585 169.609 220.706 167.407 217.569 165.625C214.462 163.823 211.17 162.361 207.75 161.264C204.583 160.238 201.305 159.594 197.986 159.344L197.09 146.261ZM227.753 238.599V252.861L213.765 244.724V230.462L227.753 238.599Z",
    fill: "#C3337F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mast_Schatten"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.84 139.417L193.125 138.672L193.124 138.672L193.1 138.684L174.523 133.59L175.03 134.32L174.449 133.552L171.734 132.807L170.146 133.533L170.163 133.555L167.356 134.891L153.374 126.326L139.107 133.621L139.109 133.624L139.104 133.621L137.516 134.348L145.395 145.268L134.455 150.476L132.865 151.202L132.882 151.224L122.051 156.38L122.012 156.37L122.029 156.391L121.995 156.407L123.117 157.879L121.561 158.591L122.686 160.062L110.5 165.863L111.838 165.227L124.48 168.571L128.677 167.897L129.426 168.877L128.073 169.521L124.48 168.571L119.208 169.416L124.97 170.998L116.942 174.82L113.653 170.308L119.208 169.416L111.45 167.286L110.435 165.894L107.762 165.161L106.21 165.899L107.332 167.371L98.4362 171.606L95.7628 170.873L94.2118 171.611L95.3339 173.083L94.8159 173.33L95.4449 173.229L101.038 180.568L104.6 176.974L94.8159 173.33L99.253 175.507L92.2788 178.827L102.368 192.066L111.45 200.795L154.589 176.947L154.576 176.943L156.124 176.207L156.137 176.21L156.131 176.203L165.48 171.753L176.951 186.88L176.971 186.952L176.996 186.94L177.001 186.946L178.281 186.337L176.992 186.957L179.665 187.69L198.38 192.796L198.39 192.808L198.383 192.811L201.057 193.545L202.579 192.814L199.938 192.089L199.942 192.088L202.584 192.813L193.394 158.542L205.82 152.627L195.84 139.417ZM176.963 180.556L177.303 181.824L177.307 181.828L176.964 180.557L176.963 180.556ZM169.773 160.19L168.238 154.479L161.187 157.838L169.773 160.19ZM171.086 165.07L170.425 162.614L160.707 159.894L165.925 166.789L165.907 166.764L166.936 167.045L171.086 165.07ZM174.481 177.694L172.611 170.74L169.487 169.845L168.569 170.282L174.648 178.314L174.644 178.301L174.15 177.604L174.481 177.694ZM181.168 186.93L181.184 186.922L181.136 186.854L181.15 186.906L181.168 186.93ZM179.649 181.31L180.828 185.705L196.198 189.915L192.382 184.879L192.378 184.88L179.649 181.31ZM184.136 174.04L177.165 172.044L179.013 178.936L190.201 182L184.162 174.028L184.136 174.04ZM176.529 169.674L175.773 166.853L177.943 165.82L181.997 171.172L176.529 169.674ZM174.7 161.539L174.155 160.82L174.32 161.435L174.7 161.539ZM192.808 182.714L185.682 173.304L185.687 173.302L185.239 172.703L192.822 182.718L192.808 182.714ZM197.25 188.565L193.908 184.152L193.899 184.156L197.256 188.589L197.25 188.565ZM184.609 171.887L184.624 171.891L179.475 165.09L179.465 165.095L184.609 171.887ZM196.081 184.219L189.654 160.323L181.085 164.402L196.081 184.219ZM198.075 185.261L198.737 187.729L198.74 187.734L198.075 185.261ZM176.681 136.505L189.997 140.161L182.234 143.856L176.681 136.505ZM170.948 137.218L174.931 139.799L172.423 136.515L170.948 137.218ZM161.032 137.902L164.966 136.029L154.454 129.209L161.032 137.902ZM176.415 143.457L168.556 138.358L164.634 140.227L176.415 143.457ZM199.472 149.774L193.844 142.366L186.027 146.091L199.472 149.774ZM191.181 155.582L185.674 148.293L198.906 151.904L191.181 155.582ZM153.374 133.873L154.1 134.348L153.839 134.003L153.374 133.873ZM158.231 137.052L158.258 137.07L155.412 133.311L155.402 133.316L158.231 137.052ZM148.558 143.84L153.418 141.526L144.976 139.108L148.558 143.84ZM156.337 140.137L157.747 139.465L145.893 131.774L140.248 134.891L156.337 140.137ZM158.714 143.043L160.986 143.694L165.557 149.678L152.375 146.064L158.714 143.043ZM169.924 149.653L177.452 146.069L164.527 142.521L169.924 149.653ZM151.901 148.258L165.172 151.901L157.443 155.58L151.901 148.258ZM155.877 156.326L149.208 147.518L149.207 147.518L155.877 156.326ZM139.622 152.056L153.283 155.67L147.644 148.234L139.622 152.056ZM144.918 161.479L139.388 154.159L152.648 157.799L144.918 161.479ZM178.852 161.452L186.525 157.799L173.372 154.209L178.852 161.452ZM187.045 155.656L181.435 148.274L173.646 151.986L187.045 155.656ZM135.143 154.185L140.802 161.595L127.163 157.987L135.143 154.185ZM132.508 167.387L132.438 167.294L132.838 167.23L132.508 167.387ZM156.563 160.036L148.603 163.829L162.172 167.418L156.563 160.036ZM153.89 173.256L161.628 169.572L148.305 165.914L153.89 173.256ZM108.805 182.706L116.767 178.916L122.396 186.301L108.805 182.706ZM125.04 187.001L126.377 186.364L121.207 179.273L133.935 182.766L125.04 187.001ZM120.803 176.995L128.765 173.204L134.395 180.59L120.803 176.995ZM137.038 181.289L149.184 175.507L133.166 171.11L131.868 171.727L138.375 180.652L137.038 181.289ZM134.649 170.403L144.049 165.928L149.729 173.353L136.053 169.735L134.649 170.403ZM112.628 174.321L110.014 170.891L103.571 171.925L112.628 174.321ZM101.08 172.325L103.571 171.925L99.8402 170.938L98.4362 171.606L101.08 172.325ZM101.08 172.325L98.4362 171.606L99.1822 172.629L101.08 172.325ZM99.4512 172.998L112.972 176.71L103.469 181.234L103.471 181.236L103.467 181.235L103.541 181.199L104.944 180.531L99.4512 172.998ZM121.937 188.478L108.235 184.717L113.986 192.263L121.937 188.478Z",
    fill: "url(#paint0_linear_1405_8844)",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Strommast"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mast"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mast_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    d: "M90.3552 174.567L112.185 161.962L134.014 174.567L112.185 187.17L90.3552 174.567Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    d: "M90.3552 174.567V187.17L112.185 199.774V187.17L90.3552 174.567Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    d: "M112.185 199.774L134.014 187.17V174.567L112.185 187.17V199.774Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    d: "M112.185 144.786V141.982L129.159 151.906V154.587L112.185 144.786Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    d: "M112.185 141.982L114.612 140.58L129.159 149.37V151.906L112.185 141.982Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    d: "M109.757 163.36V94.039L112.184 95.4409V164.762L109.757 163.36Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    d: "M114.612 163.36V94.039L112.185 95.4409V164.762L114.612 163.36Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    d: "M112.185 123.105V120.301L129.159 130.106V132.904L112.185 123.105Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    d: "M112.185 120.301L114.612 118.899L129.159 127.688V130.224L112.185 120.301Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    d: "M112.185 144.786V141.982L95.2102 151.906V154.587L112.185 144.786Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    d: "M112.185 141.982L109.757 140.58L95.2102 149.37V151.906L112.185 141.982Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    d: "M112.185 123.105V120.301L95.2102 130.223V132.904L112.185 123.105Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    d: "M112.185 120.301L109.757 118.899L95.2102 127.688V130.224L112.185 120.301Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    d: "M90.3552 174.567V105.247L92.7828 106.649V175.969L90.3552 174.567Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    d: "M95.2103 174.567V105.247L92.7827 106.649V175.969L95.2103 174.567Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    d: "M109.757 185.768V116.448L112.184 117.85V187.17L109.757 185.768Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    d: "M114.612 185.768L114.583 113.653L112.154 115.055L112.185 187.17L114.612 185.768Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    d: "M129.159 174.567V105.247L131.587 106.649V175.969L129.159 174.567Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    d: "M134.014 174.567L133.981 102.507L131.553 103.909L131.587 175.969L134.014 174.567Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    d: "M112.185 73.0333V70.2294L129.159 80.0343V82.8323L112.185 73.0333Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    d: "M112.185 70.2293L114.612 68.8273L129.159 77.6152V80.1518L112.185 70.2293Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    d: "M112.185 95.5468V92.7429L129.159 102.548V105.347L112.185 95.5468Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    d: "M112.185 92.7432L114.612 91.3413L129.159 100.131V102.667L112.185 92.7432Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_512",
    d: "M92.7827 155.993V153.189L109.757 163.113V165.794L92.7827 155.993Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_513",
    d: "M92.7827 153.189L95.2103 151.787L109.757 160.577V163.113L92.7827 153.189Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_514",
    d: "M92.7827 134.312V131.508L109.757 141.432V144.112L92.7827 134.312Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_515",
    d: "M92.7827 131.508L95.2103 130.106L109.757 138.895V141.432L92.7827 131.508Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_516",
    d: "M131.587 156.111V153.308L114.612 163.231V165.911L131.587 156.111Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_517",
    d: "M131.587 153.308L129.159 151.906L114.612 160.694V163.231L131.587 153.308Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_518",
    d: "M131.587 134.429V131.626L114.612 141.55V144.23L131.587 134.429Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_519",
    d: "M131.587 131.625L129.159 130.224L114.612 139.013V141.549L131.587 131.625Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_520",
    d: "M131.587 106.688L131.552 103.867L112.214 115.055L112.212 117.834L131.587 106.688Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_521",
    d: "M134.014 102.443L131.585 101.042L109.786 113.653L112.214 115.055L134.014 102.443Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_522",
    d: "M112.185 95.4904L112.128 92.6603L92.7827 103.853L92.7812 106.648L112.185 95.4904Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_523",
    d: "M114.583 91.2394L112.154 89.8389L90.3552 102.45L92.7828 103.852L114.583 91.2394Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_524",
    d: "M90.3667 105.346V80.0212L92.7958 81.4231V106.748L90.3667 105.346Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_525",
    d: "M95.2233 102.475V80.0212L92.7957 81.4231V103.877L95.2233 102.475Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_526",
    d: "M109.674 91.2758L109.68 68.7664L112.135 70.1857V92.6966L109.674 91.2758Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_527",
    d: "M114.563 91.2961V68.7838L112.135 70.1857V92.6966L114.563 91.2961Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_528",
    d: "M114.563 71.5543V68.7809L92.7957 81.423V84.1615L114.563 71.5543Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_529",
    d: "M114.563 68.7809L112.097 67.3586L90.3667 80.0211L92.7958 81.423L114.563 68.7809Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_530",
    d: "M109.783 113.703V91.2484L112.212 92.6503V115.105L109.783 113.703Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_531",
    d: "M114.64 113.703V91.2484L112.212 92.6503V115.105L114.64 113.703Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_532",
    d: "M129.091 102.503L129.097 79.9949L131.552 81.4129V103.925L129.091 102.503Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_533",
    d: "M133.979 102.523V80.0109L131.552 81.4129V103.925L133.979 102.523Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_534",
    d: "M134.016 82.8294L133.979 80.0081L112.212 92.6502V95.3887L134.016 82.8294Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_535",
    d: "M133.979 80.008L131.515 78.5858L109.783 91.2482L112.212 92.6502L133.979 80.008Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_536",
    d: "M92.7827 106.754V103.95L109.757 113.874V116.554L92.7827 106.754Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_537",
    d: "M92.7827 103.95L95.2103 102.548L109.757 111.337V113.874L92.7827 103.95Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_538",
    d: "M92.7827 84.2399V81.436L109.757 91.3585V94.0389L92.7827 84.2399Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_539",
    d: "M92.7827 81.4362L95.2103 80.0343L109.757 88.8237V91.3588L92.7827 81.4362Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_540",
    d: "M90.3667 80.0108V57.5566L92.7958 58.9585V81.4128L90.3667 80.0108Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_541",
    d: "M95.2233 80.0108V57.5566L92.7957 58.9585V81.4128L95.2233 80.0108Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_542",
    d: "M109.674 68.8115L109.68 46.3021L112.135 47.7214V70.2323L109.674 68.8115Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_543",
    d: "M114.563 68.8304V46.3195L112.135 47.7214V70.2323L114.563 68.8304Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_544",
    d: "M159.317 22.9689V20.197L45.9319 86.1055V88.844L159.317 22.9689Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_545",
    d: "M114.563 46.3166L112.097 44.8943L90.3667 57.5568L92.7958 58.9587L114.563 46.3166Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_546",
    d: "M159.329 20.1707L156.863 18.747L43.5156 84.6817L45.9432 86.0836L159.329 20.1707Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_547",
    d: "M112.135 50.525V47.7211L129.11 57.526V60.3255L112.135 50.525Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_548",
    d: "M112.135 47.7214L114.563 46.3195L131.515 56.1214L129.11 57.6454L112.135 47.7214Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_549",
    d: "M159.489 22.8349L159.454 20.0135L114.466 23.9128V26.6513L159.489 22.8349Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_550",
    d: "M159.452 20.0109L156.676 18.7775L112.035 22.5141L114.464 23.9146L159.452 20.0109Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_551",
    d: "M92.7957 61.7625V58.9586L109.686 68.7373L107.466 70.0245L92.7957 61.7625Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_552",
    d: "M92.7957 58.9586L95.1041 57.5974L112.097 67.4356L109.85 68.8317L92.7957 58.9586Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_553",
    d: "M90.2722 57.6625V35.2083L92.6998 36.6102V59.0644L90.2722 57.6625Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_554",
    d: "M95.1273 57.6625V35.2083L92.6997 36.6102V59.0644L95.1273 57.6625Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_555",
    d: "M109.578 46.4632L109.586 23.9552L112.039 25.3731V47.8855L109.578 46.4632Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_556",
    d: "M114.468 46.4836V23.9712L112.039 25.3731V47.8855L114.468 46.4836Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_557",
    d: "M114.468 26.7417V23.9683L92.6997 36.6105V39.349L114.468 26.7417Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_558",
    d: "M114.468 23.9683L112.003 22.546L90.2722 35.2085L92.6998 36.6104L114.468 23.9683Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_559",
    d: "M126.89 42.0509V39.247L143.946 49.1201L141.846 50.2214L126.89 42.0509Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_560",
    d: "M126.89 39.2471L129.2 37.8858L146.193 47.7241L143.946 49.1202L126.89 39.2471Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_561",
    d: "M142.676 32.5585V29.7546L159.731 39.6278L158.119 41.2316L142.676 32.5585Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_562",
    d: "M142.676 29.7546L144.986 28.3934L161.979 38.2316L159.731 39.6278L142.676 29.7546Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_563",
    d: "M157.023 24.1224V21.3185L174.079 31.1916L174.024 34.0144L157.023 24.1224Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_564",
    d: "M157.023 21.3185L159.333 19.9572L176.327 29.7955L174.079 31.1916L157.023 21.3185Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_565",
    d: "M109.783 91.238V68.7838L112.212 70.1857V92.6399L109.783 91.238Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_566",
    d: "M114.64 91.238V68.7838L112.212 70.1857V92.6399L114.64 91.238Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_567",
    d: "M129.091 80.0386L129.097 57.5306L131.552 58.9486V81.4609L129.091 80.0386Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_568",
    d: "M133.979 80.059V57.5466L131.552 58.9486V81.4609L133.979 80.059Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_569",
    d: "M178.769 34.2436L178.734 31.4238L65.3481 97.3323V100.071L178.769 34.2436Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_570",
    d: "M178.732 31.4211L175.956 30.1863L62.9189 95.9321L65.3465 97.334L178.732 31.4211Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_571",
    d: "M178.769 34.2436L178.734 31.4238L133.746 35.323V38.0615L178.769 34.2436Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_572",
    d: "M178.732 31.4211L176.326 29.7954L131.315 33.9228L133.742 35.3247L178.732 31.4211Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_573",
    d: "M112.135 28.3686V25.5648L129.11 35.3696V38.1677L112.135 28.3686Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_574",
    d: "M112.135 25.565L114.563 24.163L131.515 33.965L129.11 35.4875L112.135 25.565Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_575",
    d: "M109.689 68.8897V46.4354L112.116 47.8374V70.2916L109.689 68.8897Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_576",
    d: "M114.544 68.8897V46.4354L112.116 47.8374V70.2916L114.544 68.8897Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_577",
    d: "M128.995 57.6904L129.002 35.1824L131.456 36.6003V59.1127L128.995 57.6904Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_578",
    d: "M133.885 57.7107V35.1984L131.456 36.6003V59.1127L133.885 57.7107Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_579",
    d: "M133.92 38.0168L133.885 35.1969L112.116 47.8376V50.5761L133.92 38.0168Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_580",
    d: "M133.885 35.1969L131.419 33.7732L109.689 46.4357L112.116 47.8376L133.885 35.1969Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_581",
    d: "M92.7012 39.3837V36.5798L109.689 46.405V49.2612L92.7012 39.3837Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_582",
    d: "M92.7012 36.5798L95.0096 35.2186L112.003 45.0568L109.755 46.453L92.7012 36.5798Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_583",
    d: "M90.2722 35.239V12.7848L92.7013 14.1867V36.641L90.2722 35.239Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_584",
    d: "M95.1288 35.239V12.7848L92.7012 14.1867V36.641L95.1288 35.239Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_585",
    d: "M109.58 24.0394L109.586 1.53137L112.041 2.94929V25.4617L109.58 24.0394Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_586",
    d: "M114.468 24.0597V1.54736L112.041 2.9493V25.4617L114.468 24.0597Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_587",
    d: "M114.468 4.31787V1.54596L92.7012 14.1866V16.9251L114.468 4.31787Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_588",
    d: "M114.468 1.54592L112.003 0.122192L90.2722 12.7847L92.7013 14.1866L114.468 1.54592Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_589",
    d: "M111.952 5.74583V2.94196L128.925 12.7468V15.5449L111.952 5.74583Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_590",
    d: "M111.952 2.94216L114.38 1.54022L131.331 11.3422L128.925 12.8647L111.952 2.94216Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_591",
    d: "M109.689 46.4662V24.012L112.118 25.4139V47.8682L109.689 46.4662Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_592",
    d: "M114.545 46.4662V24.012L112.118 25.4139V47.8682L114.545 46.4662Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_593",
    d: "M128.996 35.2666L129.002 12.7585L131.457 14.1765V36.6888L128.996 35.2666Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_594",
    d: "M133.885 35.2869V12.7745L131.457 14.1765V36.6888L133.885 35.2869Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_595",
    d: "M133.921 15.5929L133.885 12.7731L112.118 25.4138V28.1523L133.921 15.5929Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_596",
    d: "M133.885 12.7731L131.419 11.3494L109.689 24.0118L112.118 25.4138L133.885 12.7731Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_597",
    d: "M92.6577 16.9819V14.1794L109.645 24.0046V26.8608L92.6577 16.9819Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_598",
    d: "M92.6577 14.1794L94.9662 12.8181L111.959 22.6549L109.713 24.0511L92.6577 14.1794Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_599",
    d: "M43.5085 87.4505L43.5158 84.6888L45.9434 86.0907L45.9361 88.8525L43.5085 87.4505Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_600",
    d: "M62.9133 98.6966L62.9206 95.9348L65.3497 97.3368L65.3409 100.099L62.9133 98.6966Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_601",
    d: "M92.7389 36.6596L90.2735 35.2374L43.5156 84.6815L45.9432 86.0834L92.7389 36.6596Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_602",
    d: "M92.684 39.4507V36.6788L45.9319 86.1054V88.8439L92.684 39.4507Z",
    fill: "#747773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_603",
    d: "M76.853 70.925V68.1226L93.9087 77.9942L91.8095 79.0969L76.853 70.925Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_604",
    d: "M76.853 68.1229L79.163 66.7617L96.1562 76.5985L93.9087 77.9946L76.853 68.1229Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_605",
    d: "M58.9907 81.2634V78.4595L76.0464 88.3327L74.4338 89.9365L58.9907 81.2634Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_606",
    d: "M58.9907 78.4595L61.3007 77.0982L78.2939 86.9365L76.0464 88.3326L58.9907 78.4595Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_607",
    d: "M45.9143 88.8047V86.0008L62.9686 95.8739L62.9134 98.6967L45.9143 88.8047Z",
    fill: "#B3B2AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_608",
    d: "M45.9143 86.0007L48.2228 84.6409L65.216 94.4777L62.9686 95.8739L45.9143 86.0007Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_609",
    d: "M112.166 47.9276L109.7 46.5053L62.9424 95.9494L65.37 97.3514L112.166 47.9276Z",
    fill: "#D1D2D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_610",
    d: "M112.109 50.7183V47.9464L65.3586 97.3731V100.112L112.109 50.7183Z",
    fill: "#747773"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Busch"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Busch klein"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_611",
    d: "M409.3 181.203C404.445 183.928 404.445 188.424 409.3 191.266C414.768 194.049 421.237 194.049 426.704 191.266C431.558 188.542 431.558 184.045 426.704 181.203C421.237 178.42 414.768 178.42 409.3 181.203Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_612",
    d: "M413.287 159.478C404.263 159.478 396.948 167.112 396.948 176.528C396.948 185.944 404.263 193.577 413.287 193.577C422.313 193.577 429.627 185.944 429.627 176.528C429.627 167.112 422.313 159.478 413.287 159.478Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_613",
    d: "M401.565 183.748C408.865 187.417 417.472 187.417 424.772 183.748C428.091 181.853 429.624 179.367 429.624 176.881C429.881 180.349 428.009 183.628 424.89 185.168C417.59 188.837 408.984 188.837 401.684 185.168C398.984 183.641 397.178 180.911 396.829 177.828C397.443 180.409 399.181 182.582 401.565 183.748Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_614",
    d: "M403.227 173.21C409.555 176.408 417.026 176.408 423.354 173.21C425.475 172.217 427.009 170.289 427.499 168C427.855 170.25 426.433 172.61 423.354 174.394C417.026 177.592 409.555 177.592 403.227 174.394C400.149 172.617 398.847 170.25 399.083 168C399.541 170.305 401.085 172.245 403.227 173.21Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Busch klein_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_615",
    d: "M395.625 194.332C392.076 196.323 392.076 199.609 395.625 201.687C399.621 203.721 404.35 203.721 408.346 201.687C411.893 199.696 411.893 196.409 408.346 194.332C404.35 192.298 399.621 192.298 395.625 194.332Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_616",
    d: "M397.779 177.648C391.183 177.648 385.836 183.228 385.836 190.111C385.836 196.994 391.183 202.573 397.779 202.573C404.376 202.573 409.722 196.994 409.722 190.111C409.722 183.228 404.376 177.648 397.779 177.648Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_617",
    d: "M389.213 195.384C394.549 198.066 400.84 198.066 406.175 195.384C408.602 193.999 409.722 192.182 409.722 190.365C409.91 192.9 408.542 195.297 406.262 196.422C400.927 199.104 394.636 199.104 389.3 196.422C387.327 195.306 386.007 193.311 385.752 191.057C386.201 192.944 387.471 194.532 389.213 195.384Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_618",
    d: "M390.43 187.68C395.056 190.017 400.517 190.017 405.142 187.68C406.692 186.954 407.813 185.545 408.171 183.872C408.432 185.517 407.392 187.242 405.142 188.546C400.517 190.883 395.056 190.883 390.43 188.546C388.181 187.247 387.229 185.517 387.402 183.872C387.736 185.557 388.864 186.975 390.43 187.68Z",
    fill: "#D9D9D0"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "dot-einspeiseanfrage",
    cx: 130.321,
    cy: 196.424,
    r: 6.31184,
    fill: "#B4005F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1405_8844",
    x1: 111.426,
    y1: 190.894,
    x2: 197.633,
    y2: 134.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118587
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEinspeiseanfrage);
export default __webpack_public_path__ + "static/media/Einspeiseanfrage.5943ffed5ed0f8bed1d19e333fe64834.svg";
export { ForwardRef as ReactComponent };